/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _search = __webpack_require__(1);
	
	var _search2 = _interopRequireDefault(_search);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	window.searchFrom = new _search2.default('from');
	window.searchTo = new _search2.default('to');

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* globals google, $ */
	
	
	var _SearchClass = __webpack_require__(3);
	
	var _SearchClass2 = _interopRequireDefault(_SearchClass);
	
	var _SearchResultsList = __webpack_require__(12);
	
	var _SearchResultsList2 = _interopRequireDefault(_SearchResultsList);
	
	var _alphanum = __webpack_require__(15);
	
	var _alphanum2 = _interopRequireDefault(_alphanum);
	
	var _language = __webpack_require__(6);
	
	var _language2 = _interopRequireDefault(_language);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Search = function () {
	  function Search(field) {
	    var _this = this;
	
	    _classCallCheck(this, Search);
	
	    this.baseSearch = function (val) {
	      _this.result = _this.customSearch.make(val);
	      if (!_this.result.length) {
	        _this.googleSearch(val);
	      } else {
	        _this.resultList.show(_this.result);
	      }
	    };
	
	    this.googleSearch = function (val) {
	      if (val && val.length > 3) {
	        _this.googleService.getPlacePredictions({ input: val, componentRestrictions: { country: 'it' } }, function (predictions, status) {
	          if (status !== google.maps.places.PlacesServiceStatus.OK) {
	            console.log(status); // eslint-disable-line no-console
	            if (status === 'ZERO_RESULTS') {
	              _this.resultList.geocoder.geocode({ address: predictions[0].place_id }, function (results, geocodeStatus) {
	                if (geocodeStatus === google.maps.GeocoderStatus.OK) {
	                  // console.log('results', results);
	                  var place = results[0];
	                  var placeData = {};
	                  placeData.formatted_address = place.formatted_address;
	                  placeData.name = place.name;
	                  placeData.city = place.address_components.filter(function (el) {
	                    return el.types[0] === 'locality' || el.types[0] === 'administrative_area_level_3';
	                  });
	                  // console.log('place',place);
	                  // $(`input[name="${self.field}"]`).val(place.formatted_address);
	                  $('input[name="' + _this.field + 'Id"]').val('');
	                  document.getElementsByName(_this.field + 'Data')[0].value = JSON.stringify(placeData);
	                } else {
	                  console.log("Can't find address: ", geocodeStatus); // eslint-disable-line no-console
	                }
	              });
	            }
	            return;
	          }
	          _this.resultList.showGoogle(predictions);
	        });
	      }
	      // console.log('googleSearch',val);
	    };
	
	    this.field = field;
	    this.provider = this.baseSearch;
	    this.customSearch = new _SearchClass2.default(_language2.default);
	    this.googleService = new google.maps.places.AutocompleteService();
	    this.result = [];
	    this.resultList = new _SearchResultsList2.default(field);
	    this.inputStarted = false;
	    this.init();
	  }
	
	  _createClass(Search, [{
	    key: 'init',
	    value: function init() {
	      var _this2 = this;
	
	      $(document.getElementsByName(this.field)).change(function (e) {
	        if (!_this2.inputStarted) {
	          _this2.baseSearch(e.target.value);
	        }
	      });
	
	      $(document.getElementsByName(this.field)).keyup(function (e) {
	        _this2.inputStarted = true;
	        if ((0, _alphanum2.default)(e)) {
	          _this2.baseSearch(e.target.value);
	        }
	      });
	    }
	  }]);
	
	  return Search;
	}();
	
	exports.default = Search;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	module.exports = jQuery;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); // Класс поиска, зависит от библиотеки lunr
	
	
	var _lunr = __webpack_require__(4);
	
	var _lunr2 = _interopRequireDefault(_lunr);
	
	var _bases = __webpack_require__(5);
	
	var _bases2 = _interopRequireDefault(_bases);
	
	var _language = __webpack_require__(6);
	
	var _language2 = _interopRequireDefault(_language);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	__webpack_require__(7)(_lunr2.default);
	__webpack_require__(8)(_lunr2.default);
	__webpack_require__(9)(_lunr2.default);
	__webpack_require__(10)(_lunr2.default);
	__webpack_require__(11)(_lunr2.default);
	
	var Search = function () {
	  function Search(lang) {
	    _classCallCheck(this, Search);
	
	    this.language = lang || _language2.default;
	    this.init();
	  }
	
	  _createClass(Search, [{
	    key: 'init',
	    value: function init() {
	      var language = this.language;
	
	      this.index = (0, _lunr2.default)(function index() {
	        var _this = this;
	
	        this.use(_lunr2.default.multiLanguage('en', 'ru', 'pt', 'it'));
	        this.field(language);
	        this.ref('id');
	        _bases2.default.base.forEach(function (item) {
	          _this.add(item);
	        });
	      });
	    }
	  }, {
	    key: 'make',
	    value: function make(q) {
	      return this.index.search('' + q);
	    }
	  }]);
	
	  return Search;
	}();
	
	exports.default = Search;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/**
	 * lunr - http://lunrjs.com - A bit like Solr, but much smaller and not as bright - 2.1.6
	 * Copyright (C) 2018 Oliver Nightingale
	 * @license MIT
	 */
	
	;(function () {
	
	  /**
	   * A convenience function for configuring and constructing
	   * a new lunr Index.
	   *
	   * A lunr.Builder instance is created and the pipeline setup
	   * with a trimmer, stop word filter and stemmer.
	   *
	   * This builder object is yielded to the configuration function
	   * that is passed as a parameter, allowing the list of fields
	   * and other builder parameters to be customised.
	   *
	   * All documents _must_ be added within the passed config function.
	   *
	   * @example
	   * var idx = lunr(function () {
	   *   this.field('title')
	   *   this.field('body')
	   *   this.ref('id')
	   *
	   *   documents.forEach(function (doc) {
	   *     this.add(doc)
	   *   }, this)
	   * })
	   *
	   * @see {@link lunr.Builder}
	   * @see {@link lunr.Pipeline}
	   * @see {@link lunr.trimmer}
	   * @see {@link lunr.stopWordFilter}
	   * @see {@link lunr.stemmer}
	   * @namespace {function} lunr
	   */
	  var lunr = function lunr(config) {
	    var builder = new lunr.Builder();
	
	    builder.pipeline.add(lunr.trimmer, lunr.stopWordFilter, lunr.stemmer);
	
	    builder.searchPipeline.add(lunr.stemmer);
	
	    config.call(builder, builder);
	    return builder.build();
	  };
	
	  lunr.version = "2.1.6";
	  /*!
	   * lunr.utils
	   * Copyright (C) 2018 Oliver Nightingale
	   */
	
	  /**
	   * A namespace containing utils for the rest of the lunr library
	   */
	  lunr.utils = {};
	
	  /**
	   * Print a warning message to the console.
	   *
	   * @param {String} message The message to be printed.
	   * @memberOf Utils
	   */
	  lunr.utils.warn = function (global) {
	    /* eslint-disable no-console */
	    return function (message) {
	      if (global.console && console.warn) {
	        console.warn(message);
	      }
	    };
	    /* eslint-enable no-console */
	  }(this);
	
	  /**
	   * Convert an object to a string.
	   *
	   * In the case of `null` and `undefined` the function returns
	   * the empty string, in all other cases the result of calling
	   * `toString` on the passed object is returned.
	   *
	   * @param {Any} obj The object to convert to a string.
	   * @return {String} string representation of the passed object.
	   * @memberOf Utils
	   */
	  lunr.utils.asString = function (obj) {
	    if (obj === void 0 || obj === null) {
	      return "";
	    } else {
	      return obj.toString();
	    }
	  };
	  lunr.FieldRef = function (docRef, fieldName, stringValue) {
	    this.docRef = docRef;
	    this.fieldName = fieldName;
	    this._stringValue = stringValue;
	  };
	
	  lunr.FieldRef.joiner = "/";
	
	  lunr.FieldRef.fromString = function (s) {
	    var n = s.indexOf(lunr.FieldRef.joiner);
	
	    if (n === -1) {
	      throw "malformed field ref string";
	    }
	
	    var fieldRef = s.slice(0, n),
	        docRef = s.slice(n + 1);
	
	    return new lunr.FieldRef(docRef, fieldRef, s);
	  };
	
	  lunr.FieldRef.prototype.toString = function () {
	    if (this._stringValue == undefined) {
	      this._stringValue = this.fieldName + lunr.FieldRef.joiner + this.docRef;
	    }
	
	    return this._stringValue;
	  };
	  /**
	   * A function to calculate the inverse document frequency for
	   * a posting. This is shared between the builder and the index
	   *
	   * @private
	   * @param {object} posting - The posting for a given term
	   * @param {number} documentCount - The total number of documents.
	   */
	  lunr.idf = function (posting, documentCount) {
	    var documentsWithTerm = 0;
	
	    for (var fieldName in posting) {
	      if (fieldName == '_index') continue; // Ignore the term index, its not a field
	      documentsWithTerm += Object.keys(posting[fieldName]).length;
	    }
	
	    var x = (documentCount - documentsWithTerm + 0.5) / (documentsWithTerm + 0.5);
	
	    return Math.log(1 + Math.abs(x));
	  };
	
	  /**
	   * A token wraps a string representation of a token
	   * as it is passed through the text processing pipeline.
	   *
	   * @constructor
	   * @param {string} [str=''] - The string token being wrapped.
	   * @param {object} [metadata={}] - Metadata associated with this token.
	   */
	  lunr.Token = function (str, metadata) {
	    this.str = str || "";
	    this.metadata = metadata || {};
	  };
	
	  /**
	   * Returns the token string that is being wrapped by this object.
	   *
	   * @returns {string}
	   */
	  lunr.Token.prototype.toString = function () {
	    return this.str;
	  };
	
	  /**
	   * A token update function is used when updating or optionally
	   * when cloning a token.
	   *
	   * @callback lunr.Token~updateFunction
	   * @param {string} str - The string representation of the token.
	   * @param {Object} metadata - All metadata associated with this token.
	   */
	
	  /**
	   * Applies the given function to the wrapped string token.
	   *
	   * @example
	   * token.update(function (str, metadata) {
	   *   return str.toUpperCase()
	   * })
	   *
	   * @param {lunr.Token~updateFunction} fn - A function to apply to the token string.
	   * @returns {lunr.Token}
	   */
	  lunr.Token.prototype.update = function (fn) {
	    this.str = fn(this.str, this.metadata);
	    return this;
	  };
	
	  /**
	   * Creates a clone of this token. Optionally a function can be
	   * applied to the cloned token.
	   *
	   * @param {lunr.Token~updateFunction} [fn] - An optional function to apply to the cloned token.
	   * @returns {lunr.Token}
	   */
	  lunr.Token.prototype.clone = function (fn) {
	    fn = fn || function (s) {
	      return s;
	    };
	    return new lunr.Token(fn(this.str, this.metadata), this.metadata);
	  };
	  /*!
	   * lunr.tokenizer
	   * Copyright (C) 2018 Oliver Nightingale
	   */
	
	  /**
	   * A function for splitting a string into tokens ready to be inserted into
	   * the search index. Uses `lunr.tokenizer.separator` to split strings, change
	   * the value of this property to change how strings are split into tokens.
	   *
	   * This tokenizer will convert its parameter to a string by calling `toString` and
	   * then will split this string on the character in `lunr.tokenizer.separator`.
	   * Arrays will have their elements converted to strings and wrapped in a lunr.Token.
	   *
	   * @static
	   * @param {?(string|object|object[])} obj - The object to convert into tokens
	   * @returns {lunr.Token[]}
	   */
	  lunr.tokenizer = function (obj) {
	    if (obj == null || obj == undefined) {
	      return [];
	    }
	
	    if (Array.isArray(obj)) {
	      return obj.map(function (t) {
	        return new lunr.Token(lunr.utils.asString(t).toLowerCase());
	      });
	    }
	
	    var str = obj.toString().trim().toLowerCase(),
	        len = str.length,
	        tokens = [];
	
	    for (var sliceEnd = 0, sliceStart = 0; sliceEnd <= len; sliceEnd++) {
	      var char = str.charAt(sliceEnd),
	          sliceLength = sliceEnd - sliceStart;
	
	      if (char.match(lunr.tokenizer.separator) || sliceEnd == len) {
	
	        if (sliceLength > 0) {
	          tokens.push(new lunr.Token(str.slice(sliceStart, sliceEnd), {
	            position: [sliceStart, sliceLength],
	            index: tokens.length
	          }));
	        }
	
	        sliceStart = sliceEnd + 1;
	      }
	    }
	
	    return tokens;
	  };
	
	  /**
	   * The separator used to split a string into tokens. Override this property to change the behaviour of
	   * `lunr.tokenizer` behaviour when tokenizing strings. By default this splits on whitespace and hyphens.
	   *
	   * @static
	   * @see lunr.tokenizer
	   */
	  lunr.tokenizer.separator = /[\s\-]+/;
	  /*!
	   * lunr.Pipeline
	   * Copyright (C) 2018 Oliver Nightingale
	   */
	
	  /**
	   * lunr.Pipelines maintain an ordered list of functions to be applied to all
	   * tokens in documents entering the search index and queries being ran against
	   * the index.
	   *
	   * An instance of lunr.Index created with the lunr shortcut will contain a
	   * pipeline with a stop word filter and an English language stemmer. Extra
	   * functions can be added before or after either of these functions or these
	   * default functions can be removed.
	   *
	   * When run the pipeline will call each function in turn, passing a token, the
	   * index of that token in the original list of all tokens and finally a list of
	   * all the original tokens.
	   *
	   * The output of functions in the pipeline will be passed to the next function
	   * in the pipeline. To exclude a token from entering the index the function
	   * should return undefined, the rest of the pipeline will not be called with
	   * this token.
	   *
	   * For serialisation of pipelines to work, all functions used in an instance of
	   * a pipeline should be registered with lunr.Pipeline. Registered functions can
	   * then be loaded. If trying to load a serialised pipeline that uses functions
	   * that are not registered an error will be thrown.
	   *
	   * If not planning on serialising the pipeline then registering pipeline functions
	   * is not necessary.
	   *
	   * @constructor
	   */
	  lunr.Pipeline = function () {
	    this._stack = [];
	  };
	
	  lunr.Pipeline.registeredFunctions = Object.create(null);
	
	  /**
	   * A pipeline function maps lunr.Token to lunr.Token. A lunr.Token contains the token
	   * string as well as all known metadata. A pipeline function can mutate the token string
	   * or mutate (or add) metadata for a given token.
	   *
	   * A pipeline function can indicate that the passed token should be discarded by returning
	   * null. This token will not be passed to any downstream pipeline functions and will not be
	   * added to the index.
	   *
	   * Multiple tokens can be returned by returning an array of tokens. Each token will be passed
	   * to any downstream pipeline functions and all will returned tokens will be added to the index.
	   *
	   * Any number of pipeline functions may be chained together using a lunr.Pipeline.
	   *
	   * @interface lunr.PipelineFunction
	   * @param {lunr.Token} token - A token from the document being processed.
	   * @param {number} i - The index of this token in the complete list of tokens for this document/field.
	   * @param {lunr.Token[]} tokens - All tokens for this document/field.
	   * @returns {(?lunr.Token|lunr.Token[])}
	   */
	
	  /**
	   * Register a function with the pipeline.
	   *
	   * Functions that are used in the pipeline should be registered if the pipeline
	   * needs to be serialised, or a serialised pipeline needs to be loaded.
	   *
	   * Registering a function does not add it to a pipeline, functions must still be
	   * added to instances of the pipeline for them to be used when running a pipeline.
	   *
	   * @param {lunr.PipelineFunction} fn - The function to check for.
	   * @param {String} label - The label to register this function with
	   */
	  lunr.Pipeline.registerFunction = function (fn, label) {
	    if (label in this.registeredFunctions) {
	      lunr.utils.warn('Overwriting existing registered function: ' + label);
	    }
	
	    fn.label = label;
	    lunr.Pipeline.registeredFunctions[fn.label] = fn;
	  };
	
	  /**
	   * Warns if the function is not registered as a Pipeline function.
	   *
	   * @param {lunr.PipelineFunction} fn - The function to check for.
	   * @private
	   */
	  lunr.Pipeline.warnIfFunctionNotRegistered = function (fn) {
	    var isRegistered = fn.label && fn.label in this.registeredFunctions;
	
	    if (!isRegistered) {
	      lunr.utils.warn('Function is not registered with pipeline. This may cause problems when serialising the index.\n', fn);
	    }
	  };
	
	  /**
	   * Loads a previously serialised pipeline.
	   *
	   * All functions to be loaded must already be registered with lunr.Pipeline.
	   * If any function from the serialised data has not been registered then an
	   * error will be thrown.
	   *
	   * @param {Object} serialised - The serialised pipeline to load.
	   * @returns {lunr.Pipeline}
	   */
	  lunr.Pipeline.load = function (serialised) {
	    var pipeline = new lunr.Pipeline();
	
	    serialised.forEach(function (fnName) {
	      var fn = lunr.Pipeline.registeredFunctions[fnName];
	
	      if (fn) {
	        pipeline.add(fn);
	      } else {
	        throw new Error('Cannot load unregistered function: ' + fnName);
	      }
	    });
	
	    return pipeline;
	  };
	
	  /**
	   * Adds new functions to the end of the pipeline.
	   *
	   * Logs a warning if the function has not been registered.
	   *
	   * @param {lunr.PipelineFunction[]} functions - Any number of functions to add to the pipeline.
	   */
	  lunr.Pipeline.prototype.add = function () {
	    var fns = Array.prototype.slice.call(arguments);
	
	    fns.forEach(function (fn) {
	      lunr.Pipeline.warnIfFunctionNotRegistered(fn);
	      this._stack.push(fn);
	    }, this);
	  };
	
	  /**
	   * Adds a single function after a function that already exists in the
	   * pipeline.
	   *
	   * Logs a warning if the function has not been registered.
	   *
	   * @param {lunr.PipelineFunction} existingFn - A function that already exists in the pipeline.
	   * @param {lunr.PipelineFunction} newFn - The new function to add to the pipeline.
	   */
	  lunr.Pipeline.prototype.after = function (existingFn, newFn) {
	    lunr.Pipeline.warnIfFunctionNotRegistered(newFn);
	
	    var pos = this._stack.indexOf(existingFn);
	    if (pos == -1) {
	      throw new Error('Cannot find existingFn');
	    }
	
	    pos = pos + 1;
	    this._stack.splice(pos, 0, newFn);
	  };
	
	  /**
	   * Adds a single function before a function that already exists in the
	   * pipeline.
	   *
	   * Logs a warning if the function has not been registered.
	   *
	   * @param {lunr.PipelineFunction} existingFn - A function that already exists in the pipeline.
	   * @param {lunr.PipelineFunction} newFn - The new function to add to the pipeline.
	   */
	  lunr.Pipeline.prototype.before = function (existingFn, newFn) {
	    lunr.Pipeline.warnIfFunctionNotRegistered(newFn);
	
	    var pos = this._stack.indexOf(existingFn);
	    if (pos == -1) {
	      throw new Error('Cannot find existingFn');
	    }
	
	    this._stack.splice(pos, 0, newFn);
	  };
	
	  /**
	   * Removes a function from the pipeline.
	   *
	   * @param {lunr.PipelineFunction} fn The function to remove from the pipeline.
	   */
	  lunr.Pipeline.prototype.remove = function (fn) {
	    var pos = this._stack.indexOf(fn);
	    if (pos == -1) {
	      return;
	    }
	
	    this._stack.splice(pos, 1);
	  };
	
	  /**
	   * Runs the current list of functions that make up the pipeline against the
	   * passed tokens.
	   *
	   * @param {Array} tokens The tokens to run through the pipeline.
	   * @returns {Array}
	   */
	  lunr.Pipeline.prototype.run = function (tokens) {
	    var stackLength = this._stack.length;
	
	    for (var i = 0; i < stackLength; i++) {
	      var fn = this._stack[i];
	      var memo = [];
	
	      for (var j = 0; j < tokens.length; j++) {
	        var result = fn(tokens[j], j, tokens);
	
	        if (result === void 0 || result === '') continue;
	
	        if (result instanceof Array) {
	          for (var k = 0; k < result.length; k++) {
	            memo.push(result[k]);
	          }
	        } else {
	          memo.push(result);
	        }
	      }
	
	      tokens = memo;
	    }
	
	    return tokens;
	  };
	
	  /**
	   * Convenience method for passing a string through a pipeline and getting
	   * strings out. This method takes care of wrapping the passed string in a
	   * token and mapping the resulting tokens back to strings.
	   *
	   * @param {string} str - The string to pass through the pipeline.
	   * @returns {string[]}
	   */
	  lunr.Pipeline.prototype.runString = function (str) {
	    var token = new lunr.Token(str);
	
	    return this.run([token]).map(function (t) {
	      return t.toString();
	    });
	  };
	
	  /**
	   * Resets the pipeline by removing any existing processors.
	   *
	   */
	  lunr.Pipeline.prototype.reset = function () {
	    this._stack = [];
	  };
	
	  /**
	   * Returns a representation of the pipeline ready for serialisation.
	   *
	   * Logs a warning if the function has not been registered.
	   *
	   * @returns {Array}
	   */
	  lunr.Pipeline.prototype.toJSON = function () {
	    return this._stack.map(function (fn) {
	      lunr.Pipeline.warnIfFunctionNotRegistered(fn);
	
	      return fn.label;
	    });
	  };
	  /*!
	   * lunr.Vector
	   * Copyright (C) 2018 Oliver Nightingale
	   */
	
	  /**
	   * A vector is used to construct the vector space of documents and queries. These
	   * vectors support operations to determine the similarity between two documents or
	   * a document and a query.
	   *
	   * Normally no parameters are required for initializing a vector, but in the case of
	   * loading a previously dumped vector the raw elements can be provided to the constructor.
	   *
	   * For performance reasons vectors are implemented with a flat array, where an elements
	   * index is immediately followed by its value. E.g. [index, value, index, value]. This
	   * allows the underlying array to be as sparse as possible and still offer decent
	   * performance when being used for vector calculations.
	   *
	   * @constructor
	   * @param {Number[]} [elements] - The flat list of element index and element value pairs.
	   */
	  lunr.Vector = function (elements) {
	    this._magnitude = 0;
	    this.elements = elements || [];
	  };
	
	  /**
	   * Calculates the position within the vector to insert a given index.
	   *
	   * This is used internally by insert and upsert. If there are duplicate indexes then
	   * the position is returned as if the value for that index were to be updated, but it
	   * is the callers responsibility to check whether there is a duplicate at that index
	   *
	   * @param {Number} insertIdx - The index at which the element should be inserted.
	   * @returns {Number}
	   */
	  lunr.Vector.prototype.positionForIndex = function (index) {
	    // For an empty vector the tuple can be inserted at the beginning
	    if (this.elements.length == 0) {
	      return 0;
	    }
	
	    var start = 0,
	        end = this.elements.length / 2,
	        sliceLength = end - start,
	        pivotPoint = Math.floor(sliceLength / 2),
	        pivotIndex = this.elements[pivotPoint * 2];
	
	    while (sliceLength > 1) {
	      if (pivotIndex < index) {
	        start = pivotPoint;
	      }
	
	      if (pivotIndex > index) {
	        end = pivotPoint;
	      }
	
	      if (pivotIndex == index) {
	        break;
	      }
	
	      sliceLength = end - start;
	      pivotPoint = start + Math.floor(sliceLength / 2);
	      pivotIndex = this.elements[pivotPoint * 2];
	    }
	
	    if (pivotIndex == index) {
	      return pivotPoint * 2;
	    }
	
	    if (pivotIndex > index) {
	      return pivotPoint * 2;
	    }
	
	    if (pivotIndex < index) {
	      return (pivotPoint + 1) * 2;
	    }
	  };
	
	  /**
	   * Inserts an element at an index within the vector.
	   *
	   * Does not allow duplicates, will throw an error if there is already an entry
	   * for this index.
	   *
	   * @param {Number} insertIdx - The index at which the element should be inserted.
	   * @param {Number} val - The value to be inserted into the vector.
	   */
	  lunr.Vector.prototype.insert = function (insertIdx, val) {
	    this.upsert(insertIdx, val, function () {
	      throw "duplicate index";
	    });
	  };
	
	  /**
	   * Inserts or updates an existing index within the vector.
	   *
	   * @param {Number} insertIdx - The index at which the element should be inserted.
	   * @param {Number} val - The value to be inserted into the vector.
	   * @param {function} fn - A function that is called for updates, the existing value and the
	   * requested value are passed as arguments
	   */
	  lunr.Vector.prototype.upsert = function (insertIdx, val, fn) {
	    this._magnitude = 0;
	    var position = this.positionForIndex(insertIdx);
	
	    if (this.elements[position] == insertIdx) {
	      this.elements[position + 1] = fn(this.elements[position + 1], val);
	    } else {
	      this.elements.splice(position, 0, insertIdx, val);
	    }
	  };
	
	  /**
	   * Calculates the magnitude of this vector.
	   *
	   * @returns {Number}
	   */
	  lunr.Vector.prototype.magnitude = function () {
	    if (this._magnitude) return this._magnitude;
	
	    var sumOfSquares = 0,
	        elementsLength = this.elements.length;
	
	    for (var i = 1; i < elementsLength; i += 2) {
	      var val = this.elements[i];
	      sumOfSquares += val * val;
	    }
	
	    return this._magnitude = Math.sqrt(sumOfSquares);
	  };
	
	  /**
	   * Calculates the dot product of this vector and another vector.
	   *
	   * @param {lunr.Vector} otherVector - The vector to compute the dot product with.
	   * @returns {Number}
	   */
	  lunr.Vector.prototype.dot = function (otherVector) {
	    var dotProduct = 0,
	        a = this.elements,
	        b = otherVector.elements,
	        aLen = a.length,
	        bLen = b.length,
	        aVal = 0,
	        bVal = 0,
	        i = 0,
	        j = 0;
	
	    while (i < aLen && j < bLen) {
	      aVal = a[i], bVal = b[j];
	      if (aVal < bVal) {
	        i += 2;
	      } else if (aVal > bVal) {
	        j += 2;
	      } else if (aVal == bVal) {
	        dotProduct += a[i + 1] * b[j + 1];
	        i += 2;
	        j += 2;
	      }
	    }
	
	    return dotProduct;
	  };
	
	  /**
	   * Calculates the cosine similarity between this vector and another
	   * vector.
	   *
	   * @param {lunr.Vector} otherVector - The other vector to calculate the
	   * similarity with.
	   * @returns {Number}
	   */
	  lunr.Vector.prototype.similarity = function (otherVector) {
	    return this.dot(otherVector) / (this.magnitude() * otherVector.magnitude());
	  };
	
	  /**
	   * Converts the vector to an array of the elements within the vector.
	   *
	   * @returns {Number[]}
	   */
	  lunr.Vector.prototype.toArray = function () {
	    var output = new Array(this.elements.length / 2);
	
	    for (var i = 1, j = 0; i < this.elements.length; i += 2, j++) {
	      output[j] = this.elements[i];
	    }
	
	    return output;
	  };
	
	  /**
	   * A JSON serializable representation of the vector.
	   *
	   * @returns {Number[]}
	   */
	  lunr.Vector.prototype.toJSON = function () {
	    return this.elements;
	  };
	  /* eslint-disable */
	  /*!
	   * lunr.stemmer
	   * Copyright (C) 2018 Oliver Nightingale
	   * Includes code from - http://tartarus.org/~martin/PorterStemmer/js.txt
	   */
	
	  /**
	   * lunr.stemmer is an english language stemmer, this is a JavaScript
	   * implementation of the PorterStemmer taken from http://tartarus.org/~martin
	   *
	   * @static
	   * @implements {lunr.PipelineFunction}
	   * @param {lunr.Token} token - The string to stem
	   * @returns {lunr.Token}
	   * @see {@link lunr.Pipeline}
	   */
	  lunr.stemmer = function () {
	    var step2list = {
	      "ational": "ate",
	      "tional": "tion",
	      "enci": "ence",
	      "anci": "ance",
	      "izer": "ize",
	      "bli": "ble",
	      "alli": "al",
	      "entli": "ent",
	      "eli": "e",
	      "ousli": "ous",
	      "ization": "ize",
	      "ation": "ate",
	      "ator": "ate",
	      "alism": "al",
	      "iveness": "ive",
	      "fulness": "ful",
	      "ousness": "ous",
	      "aliti": "al",
	      "iviti": "ive",
	      "biliti": "ble",
	      "logi": "log"
	    },
	        step3list = {
	      "icate": "ic",
	      "ative": "",
	      "alize": "al",
	      "iciti": "ic",
	      "ical": "ic",
	      "ful": "",
	      "ness": ""
	    },
	        c = "[^aeiou]",
	        // consonant
	    v = "[aeiouy]",
	        // vowel
	    C = c + "[^aeiouy]*",
	        // consonant sequence
	    V = v + "[aeiou]*",
	        // vowel sequence
	
	    mgr0 = "^(" + C + ")?" + V + C,
	        // [C]VC... is m>0
	    meq1 = "^(" + C + ")?" + V + C + "(" + V + ")?$",
	        // [C]VC[V] is m=1
	    mgr1 = "^(" + C + ")?" + V + C + V + C,
	        // [C]VCVC... is m>1
	    s_v = "^(" + C + ")?" + v; // vowel in stem
	
	    var re_mgr0 = new RegExp(mgr0);
	    var re_mgr1 = new RegExp(mgr1);
	    var re_meq1 = new RegExp(meq1);
	    var re_s_v = new RegExp(s_v);
	
	    var re_1a = /^(.+?)(ss|i)es$/;
	    var re2_1a = /^(.+?)([^s])s$/;
	    var re_1b = /^(.+?)eed$/;
	    var re2_1b = /^(.+?)(ed|ing)$/;
	    var re_1b_2 = /.$/;
	    var re2_1b_2 = /(at|bl|iz)$/;
	    var re3_1b_2 = new RegExp("([^aeiouylsz])\\1$");
	    var re4_1b_2 = new RegExp("^" + C + v + "[^aeiouwxy]$");
	
	    var re_1c = /^(.+?[^aeiou])y$/;
	    var re_2 = /^(.+?)(ational|tional|enci|anci|izer|bli|alli|entli|eli|ousli|ization|ation|ator|alism|iveness|fulness|ousness|aliti|iviti|biliti|logi)$/;
	
	    var re_3 = /^(.+?)(icate|ative|alize|iciti|ical|ful|ness)$/;
	
	    var re_4 = /^(.+?)(al|ance|ence|er|ic|able|ible|ant|ement|ment|ent|ou|ism|ate|iti|ous|ive|ize)$/;
	    var re2_4 = /^(.+?)(s|t)(ion)$/;
	
	    var re_5 = /^(.+?)e$/;
	    var re_5_1 = /ll$/;
	    var re3_5 = new RegExp("^" + C + v + "[^aeiouwxy]$");
	
	    var porterStemmer = function porterStemmer(w) {
	      var stem, suffix, firstch, re, re2, re3, re4;
	
	      if (w.length < 3) {
	        return w;
	      }
	
	      firstch = w.substr(0, 1);
	      if (firstch == "y") {
	        w = firstch.toUpperCase() + w.substr(1);
	      }
	
	      // Step 1a
	      re = re_1a;
	      re2 = re2_1a;
	
	      if (re.test(w)) {
	        w = w.replace(re, "$1$2");
	      } else if (re2.test(w)) {
	        w = w.replace(re2, "$1$2");
	      }
	
	      // Step 1b
	      re = re_1b;
	      re2 = re2_1b;
	      if (re.test(w)) {
	        var fp = re.exec(w);
	        re = re_mgr0;
	        if (re.test(fp[1])) {
	          re = re_1b_2;
	          w = w.replace(re, "");
	        }
	      } else if (re2.test(w)) {
	        var fp = re2.exec(w);
	        stem = fp[1];
	        re2 = re_s_v;
	        if (re2.test(stem)) {
	          w = stem;
	          re2 = re2_1b_2;
	          re3 = re3_1b_2;
	          re4 = re4_1b_2;
	          if (re2.test(w)) {
	            w = w + "e";
	          } else if (re3.test(w)) {
	            re = re_1b_2;w = w.replace(re, "");
	          } else if (re4.test(w)) {
	            w = w + "e";
	          }
	        }
	      }
	
	      // Step 1c - replace suffix y or Y by i if preceded by a non-vowel which is not the first letter of the word (so cry -> cri, by -> by, say -> say)
	      re = re_1c;
	      if (re.test(w)) {
	        var fp = re.exec(w);
	        stem = fp[1];
	        w = stem + "i";
	      }
	
	      // Step 2
	      re = re_2;
	      if (re.test(w)) {
	        var fp = re.exec(w);
	        stem = fp[1];
	        suffix = fp[2];
	        re = re_mgr0;
	        if (re.test(stem)) {
	          w = stem + step2list[suffix];
	        }
	      }
	
	      // Step 3
	      re = re_3;
	      if (re.test(w)) {
	        var fp = re.exec(w);
	        stem = fp[1];
	        suffix = fp[2];
	        re = re_mgr0;
	        if (re.test(stem)) {
	          w = stem + step3list[suffix];
	        }
	      }
	
	      // Step 4
	      re = re_4;
	      re2 = re2_4;
	      if (re.test(w)) {
	        var fp = re.exec(w);
	        stem = fp[1];
	        re = re_mgr1;
	        if (re.test(stem)) {
	          w = stem;
	        }
	      } else if (re2.test(w)) {
	        var fp = re2.exec(w);
	        stem = fp[1] + fp[2];
	        re2 = re_mgr1;
	        if (re2.test(stem)) {
	          w = stem;
	        }
	      }
	
	      // Step 5
	      re = re_5;
	      if (re.test(w)) {
	        var fp = re.exec(w);
	        stem = fp[1];
	        re = re_mgr1;
	        re2 = re_meq1;
	        re3 = re3_5;
	        if (re.test(stem) || re2.test(stem) && !re3.test(stem)) {
	          w = stem;
	        }
	      }
	
	      re = re_5_1;
	      re2 = re_mgr1;
	      if (re.test(w) && re2.test(w)) {
	        re = re_1b_2;
	        w = w.replace(re, "");
	      }
	
	      // and turn initial Y back to y
	
	      if (firstch == "y") {
	        w = firstch.toLowerCase() + w.substr(1);
	      }
	
	      return w;
	    };
	
	    return function (token) {
	      return token.update(porterStemmer);
	    };
	  }();
	
	  lunr.Pipeline.registerFunction(lunr.stemmer, 'stemmer');
	  /*!
	   * lunr.stopWordFilter
	   * Copyright (C) 2018 Oliver Nightingale
	   */
	
	  /**
	   * lunr.generateStopWordFilter builds a stopWordFilter function from the provided
	   * list of stop words.
	   *
	   * The built in lunr.stopWordFilter is built using this generator and can be used
	   * to generate custom stopWordFilters for applications or non English languages.
	   *
	   * @param {Array} token The token to pass through the filter
	   * @returns {lunr.PipelineFunction}
	   * @see lunr.Pipeline
	   * @see lunr.stopWordFilter
	   */
	  lunr.generateStopWordFilter = function (stopWords) {
	    var words = stopWords.reduce(function (memo, stopWord) {
	      memo[stopWord] = stopWord;
	      return memo;
	    }, {});
	
	    return function (token) {
	      if (token && words[token.toString()] !== token.toString()) return token;
	    };
	  };
	
	  /**
	   * lunr.stopWordFilter is an English language stop word list filter, any words
	   * contained in the list will not be passed through the filter.
	   *
	   * This is intended to be used in the Pipeline. If the token does not pass the
	   * filter then undefined will be returned.
	   *
	   * @implements {lunr.PipelineFunction}
	   * @params {lunr.Token} token - A token to check for being a stop word.
	   * @returns {lunr.Token}
	   * @see {@link lunr.Pipeline}
	   */
	  lunr.stopWordFilter = lunr.generateStopWordFilter(['a', 'able', 'about', 'across', 'after', 'all', 'almost', 'also', 'am', 'among', 'an', 'and', 'any', 'are', 'as', 'at', 'be', 'because', 'been', 'but', 'by', 'can', 'cannot', 'could', 'dear', 'did', 'do', 'does', 'either', 'else', 'ever', 'every', 'for', 'from', 'get', 'got', 'had', 'has', 'have', 'he', 'her', 'hers', 'him', 'his', 'how', 'however', 'i', 'if', 'in', 'into', 'is', 'it', 'its', 'just', 'least', 'let', 'like', 'likely', 'may', 'me', 'might', 'most', 'must', 'my', 'neither', 'no', 'nor', 'not', 'of', 'off', 'often', 'on', 'only', 'or', 'other', 'our', 'own', 'rather', 'said', 'say', 'says', 'she', 'should', 'since', 'so', 'some', 'than', 'that', 'the', 'their', 'them', 'then', 'there', 'these', 'they', 'this', 'tis', 'to', 'too', 'twas', 'us', 'wants', 'was', 'we', 'were', 'what', 'when', 'where', 'which', 'while', 'who', 'whom', 'why', 'will', 'with', 'would', 'yet', 'you', 'your']);
	
	  lunr.Pipeline.registerFunction(lunr.stopWordFilter, 'stopWordFilter');
	  /*!
	   * lunr.trimmer
	   * Copyright (C) 2018 Oliver Nightingale
	   */
	
	  /**
	   * lunr.trimmer is a pipeline function for trimming non word
	   * characters from the beginning and end of tokens before they
	   * enter the index.
	   *
	   * This implementation may not work correctly for non latin
	   * characters and should either be removed or adapted for use
	   * with languages with non-latin characters.
	   *
	   * @static
	   * @implements {lunr.PipelineFunction}
	   * @param {lunr.Token} token The token to pass through the filter
	   * @returns {lunr.Token}
	   * @see lunr.Pipeline
	   */
	  lunr.trimmer = function (token) {
	    return token.update(function (s) {
	      return s.replace(/^\W+/, '').replace(/\W+$/, '');
	    });
	  };
	
	  lunr.Pipeline.registerFunction(lunr.trimmer, 'trimmer');
	  /*!
	   * lunr.TokenSet
	   * Copyright (C) 2018 Oliver Nightingale
	   */
	
	  /**
	   * A token set is used to store the unique list of all tokens
	   * within an index. Token sets are also used to represent an
	   * incoming query to the index, this query token set and index
	   * token set are then intersected to find which tokens to look
	   * up in the inverted index.
	   *
	   * A token set can hold multiple tokens, as in the case of the
	   * index token set, or it can hold a single token as in the
	   * case of a simple query token set.
	   *
	   * Additionally token sets are used to perform wildcard matching.
	   * Leading, contained and trailing wildcards are supported, and
	   * from this edit distance matching can also be provided.
	   *
	   * Token sets are implemented as a minimal finite state automata,
	   * where both common prefixes and suffixes are shared between tokens.
	   * This helps to reduce the space used for storing the token set.
	   *
	   * @constructor
	   */
	  lunr.TokenSet = function () {
	    this.final = false;
	    this.edges = {};
	    this.id = lunr.TokenSet._nextId;
	    lunr.TokenSet._nextId += 1;
	  };
	
	  /**
	   * Keeps track of the next, auto increment, identifier to assign
	   * to a new tokenSet.
	   *
	   * TokenSets require a unique identifier to be correctly minimised.
	   *
	   * @private
	   */
	  lunr.TokenSet._nextId = 1;
	
	  /**
	   * Creates a TokenSet instance from the given sorted array of words.
	   *
	   * @param {String[]} arr - A sorted array of strings to create the set from.
	   * @returns {lunr.TokenSet}
	   * @throws Will throw an error if the input array is not sorted.
	   */
	  lunr.TokenSet.fromArray = function (arr) {
	    var builder = new lunr.TokenSet.Builder();
	
	    for (var i = 0, len = arr.length; i < len; i++) {
	      builder.insert(arr[i]);
	    }
	
	    builder.finish();
	    return builder.root;
	  };
	
	  /**
	   * Creates a token set from a query clause.
	   *
	   * @private
	   * @param {Object} clause - A single clause from lunr.Query.
	   * @param {string} clause.term - The query clause term.
	   * @param {number} [clause.editDistance] - The optional edit distance for the term.
	   * @returns {lunr.TokenSet}
	   */
	  lunr.TokenSet.fromClause = function (clause) {
	    if ('editDistance' in clause) {
	      return lunr.TokenSet.fromFuzzyString(clause.term, clause.editDistance);
	    } else {
	      return lunr.TokenSet.fromString(clause.term);
	    }
	  };
	
	  /**
	   * Creates a token set representing a single string with a specified
	   * edit distance.
	   *
	   * Insertions, deletions, substitutions and transpositions are each
	   * treated as an edit distance of 1.
	   *
	   * Increasing the allowed edit distance will have a dramatic impact
	   * on the performance of both creating and intersecting these TokenSets.
	   * It is advised to keep the edit distance less than 3.
	   *
	   * @param {string} str - The string to create the token set from.
	   * @param {number} editDistance - The allowed edit distance to match.
	   * @returns {lunr.Vector}
	   */
	  lunr.TokenSet.fromFuzzyString = function (str, editDistance) {
	    var root = new lunr.TokenSet();
	
	    var stack = [{
	      node: root,
	      editsRemaining: editDistance,
	      str: str
	    }];
	
	    while (stack.length) {
	      var frame = stack.pop();
	
	      // no edit
	      if (frame.str.length > 0) {
	        var char = frame.str.charAt(0),
	            noEditNode;
	
	        if (char in frame.node.edges) {
	          noEditNode = frame.node.edges[char];
	        } else {
	          noEditNode = new lunr.TokenSet();
	          frame.node.edges[char] = noEditNode;
	        }
	
	        if (frame.str.length == 1) {
	          noEditNode.final = true;
	        } else {
	          stack.push({
	            node: noEditNode,
	            editsRemaining: frame.editsRemaining,
	            str: frame.str.slice(1)
	          });
	        }
	      }
	
	      // deletion
	      // can only do a deletion if we have enough edits remaining
	      // and if there are characters left to delete in the string
	      if (frame.editsRemaining > 0 && frame.str.length > 1) {
	        var char = frame.str.charAt(1),
	            deletionNode;
	
	        if (char in frame.node.edges) {
	          deletionNode = frame.node.edges[char];
	        } else {
	          deletionNode = new lunr.TokenSet();
	          frame.node.edges[char] = deletionNode;
	        }
	
	        if (frame.str.length <= 2) {
	          deletionNode.final = true;
	        } else {
	          stack.push({
	            node: deletionNode,
	            editsRemaining: frame.editsRemaining - 1,
	            str: frame.str.slice(2)
	          });
	        }
	      }
	
	      // deletion
	      // just removing the last character from the str
	      if (frame.editsRemaining > 0 && frame.str.length == 1) {
	        frame.node.final = true;
	      }
	
	      // substitution
	      // can only do a substitution if we have enough edits remaining
	      // and if there are characters left to substitute
	      if (frame.editsRemaining > 0 && frame.str.length >= 1) {
	        if ("*" in frame.node.edges) {
	          var substitutionNode = frame.node.edges["*"];
	        } else {
	          var substitutionNode = new lunr.TokenSet();
	          frame.node.edges["*"] = substitutionNode;
	        }
	
	        if (frame.str.length == 1) {
	          substitutionNode.final = true;
	        } else {
	          stack.push({
	            node: substitutionNode,
	            editsRemaining: frame.editsRemaining - 1,
	            str: frame.str.slice(1)
	          });
	        }
	      }
	
	      // insertion
	      // can only do insertion if there are edits remaining
	      if (frame.editsRemaining > 0) {
	        if ("*" in frame.node.edges) {
	          var insertionNode = frame.node.edges["*"];
	        } else {
	          var insertionNode = new lunr.TokenSet();
	          frame.node.edges["*"] = insertionNode;
	        }
	
	        if (frame.str.length == 0) {
	          insertionNode.final = true;
	        } else {
	          stack.push({
	            node: insertionNode,
	            editsRemaining: frame.editsRemaining - 1,
	            str: frame.str
	          });
	        }
	      }
	
	      // transposition
	      // can only do a transposition if there are edits remaining
	      // and there are enough characters to transpose
	      if (frame.editsRemaining > 0 && frame.str.length > 1) {
	        var charA = frame.str.charAt(0),
	            charB = frame.str.charAt(1),
	            transposeNode;
	
	        if (charB in frame.node.edges) {
	          transposeNode = frame.node.edges[charB];
	        } else {
	          transposeNode = new lunr.TokenSet();
	          frame.node.edges[charB] = transposeNode;
	        }
	
	        if (frame.str.length == 1) {
	          transposeNode.final = true;
	        } else {
	          stack.push({
	            node: transposeNode,
	            editsRemaining: frame.editsRemaining - 1,
	            str: charA + frame.str.slice(2)
	          });
	        }
	      }
	    }
	
	    return root;
	  };
	
	  /**
	   * Creates a TokenSet from a string.
	   *
	   * The string may contain one or more wildcard characters (*)
	   * that will allow wildcard matching when intersecting with
	   * another TokenSet.
	   *
	   * @param {string} str - The string to create a TokenSet from.
	   * @returns {lunr.TokenSet}
	   */
	  lunr.TokenSet.fromString = function (str) {
	    var node = new lunr.TokenSet(),
	        root = node,
	        wildcardFound = false;
	
	    /*
	     * Iterates through all characters within the passed string
	     * appending a node for each character.
	     *
	     * As soon as a wildcard character is found then a self
	     * referencing edge is introduced to continually match
	     * any number of any characters.
	     */
	    for (var i = 0, len = str.length; i < len; i++) {
	      var char = str[i],
	          final = i == len - 1;
	
	      if (char == "*") {
	        wildcardFound = true;
	        node.edges[char] = node;
	        node.final = final;
	      } else {
	        var next = new lunr.TokenSet();
	        next.final = final;
	
	        node.edges[char] = next;
	        node = next;
	
	        // TODO: is this needed anymore?
	        if (wildcardFound) {
	          node.edges["*"] = root;
	        }
	      }
	    }
	
	    return root;
	  };
	
	  /**
	   * Converts this TokenSet into an array of strings
	   * contained within the TokenSet.
	   *
	   * @returns {string[]}
	   */
	  lunr.TokenSet.prototype.toArray = function () {
	    var words = [];
	
	    var stack = [{
	      prefix: "",
	      node: this
	    }];
	
	    while (stack.length) {
	      var frame = stack.pop(),
	          edges = Object.keys(frame.node.edges),
	          len = edges.length;
	
	      if (frame.node.final) {
	        words.push(frame.prefix);
	      }
	
	      for (var i = 0; i < len; i++) {
	        var edge = edges[i];
	
	        stack.push({
	          prefix: frame.prefix.concat(edge),
	          node: frame.node.edges[edge]
	        });
	      }
	    }
	
	    return words;
	  };
	
	  /**
	   * Generates a string representation of a TokenSet.
	   *
	   * This is intended to allow TokenSets to be used as keys
	   * in objects, largely to aid the construction and minimisation
	   * of a TokenSet. As such it is not designed to be a human
	   * friendly representation of the TokenSet.
	   *
	   * @returns {string}
	   */
	  lunr.TokenSet.prototype.toString = function () {
	    // NOTE: Using Object.keys here as this.edges is very likely
	    // to enter 'hash-mode' with many keys being added
	    //
	    // avoiding a for-in loop here as it leads to the function
	    // being de-optimised (at least in V8). From some simple
	    // benchmarks the performance is comparable, but allowing
	    // V8 to optimize may mean easy performance wins in the future.
	
	    if (this._str) {
	      return this._str;
	    }
	
	    var str = this.final ? '1' : '0',
	        labels = Object.keys(this.edges).sort(),
	        len = labels.length;
	
	    for (var i = 0; i < len; i++) {
	      var label = labels[i],
	          node = this.edges[label];
	
	      str = str + label + node.id;
	    }
	
	    return str;
	  };
	
	  /**
	   * Returns a new TokenSet that is the intersection of
	   * this TokenSet and the passed TokenSet.
	   *
	   * This intersection will take into account any wildcards
	   * contained within the TokenSet.
	   *
	   * @param {lunr.TokenSet} b - An other TokenSet to intersect with.
	   * @returns {lunr.TokenSet}
	   */
	  lunr.TokenSet.prototype.intersect = function (b) {
	    var output = new lunr.TokenSet(),
	        frame = undefined;
	
	    var stack = [{
	      qNode: b,
	      output: output,
	      node: this
	    }];
	
	    while (stack.length) {
	      frame = stack.pop();
	
	      // NOTE: As with the #toString method, we are using
	      // Object.keys and a for loop instead of a for-in loop
	      // as both of these objects enter 'hash' mode, causing
	      // the function to be de-optimised in V8
	      var qEdges = Object.keys(frame.qNode.edges),
	          qLen = qEdges.length,
	          nEdges = Object.keys(frame.node.edges),
	          nLen = nEdges.length;
	
	      for (var q = 0; q < qLen; q++) {
	        var qEdge = qEdges[q];
	
	        for (var n = 0; n < nLen; n++) {
	          var nEdge = nEdges[n];
	
	          if (nEdge == qEdge || qEdge == '*') {
	            var node = frame.node.edges[nEdge],
	                qNode = frame.qNode.edges[qEdge],
	                final = node.final && qNode.final,
	                next = undefined;
	
	            if (nEdge in frame.output.edges) {
	              // an edge already exists for this character
	              // no need to create a new node, just set the finality
	              // bit unless this node is already final
	              next = frame.output.edges[nEdge];
	              next.final = next.final || final;
	            } else {
	              // no edge exists yet, must create one
	              // set the finality bit and insert it
	              // into the output
	              next = new lunr.TokenSet();
	              next.final = final;
	              frame.output.edges[nEdge] = next;
	            }
	
	            stack.push({
	              qNode: qNode,
	              output: next,
	              node: node
	            });
	          }
	        }
	      }
	    }
	
	    return output;
	  };
	  lunr.TokenSet.Builder = function () {
	    this.previousWord = "";
	    this.root = new lunr.TokenSet();
	    this.uncheckedNodes = [];
	    this.minimizedNodes = {};
	  };
	
	  lunr.TokenSet.Builder.prototype.insert = function (word) {
	    var node,
	        commonPrefix = 0;
	
	    if (word < this.previousWord) {
	      throw new Error("Out of order word insertion");
	    }
	
	    for (var i = 0; i < word.length && i < this.previousWord.length; i++) {
	      if (word[i] != this.previousWord[i]) break;
	      commonPrefix++;
	    }
	
	    this.minimize(commonPrefix);
	
	    if (this.uncheckedNodes.length == 0) {
	      node = this.root;
	    } else {
	      node = this.uncheckedNodes[this.uncheckedNodes.length - 1].child;
	    }
	
	    for (var i = commonPrefix; i < word.length; i++) {
	      var nextNode = new lunr.TokenSet(),
	          char = word[i];
	
	      node.edges[char] = nextNode;
	
	      this.uncheckedNodes.push({
	        parent: node,
	        char: char,
	        child: nextNode
	      });
	
	      node = nextNode;
	    }
	
	    node.final = true;
	    this.previousWord = word;
	  };
	
	  lunr.TokenSet.Builder.prototype.finish = function () {
	    this.minimize(0);
	  };
	
	  lunr.TokenSet.Builder.prototype.minimize = function (downTo) {
	    for (var i = this.uncheckedNodes.length - 1; i >= downTo; i--) {
	      var node = this.uncheckedNodes[i],
	          childKey = node.child.toString();
	
	      if (childKey in this.minimizedNodes) {
	        node.parent.edges[node.char] = this.minimizedNodes[childKey];
	      } else {
	        // Cache the key for this node since
	        // we know it can't change anymore
	        node.child._str = childKey;
	
	        this.minimizedNodes[childKey] = node.child;
	      }
	
	      this.uncheckedNodes.pop();
	    }
	  };
	  /*!
	   * lunr.Index
	   * Copyright (C) 2018 Oliver Nightingale
	   */
	
	  /**
	   * An index contains the built index of all documents and provides a query interface
	   * to the index.
	   *
	   * Usually instances of lunr.Index will not be created using this constructor, instead
	   * lunr.Builder should be used to construct new indexes, or lunr.Index.load should be
	   * used to load previously built and serialized indexes.
	   *
	   * @constructor
	   * @param {Object} attrs - The attributes of the built search index.
	   * @param {Object} attrs.invertedIndex - An index of term/field to document reference.
	   * @param {Object<string, lunr.Vector>} attrs.documentVectors - Document vectors keyed by document reference.
	   * @param {lunr.TokenSet} attrs.tokenSet - An set of all corpus tokens.
	   * @param {string[]} attrs.fields - The names of indexed document fields.
	   * @param {lunr.Pipeline} attrs.pipeline - The pipeline to use for search terms.
	   */
	  lunr.Index = function (attrs) {
	    this.invertedIndex = attrs.invertedIndex;
	    this.fieldVectors = attrs.fieldVectors;
	    this.tokenSet = attrs.tokenSet;
	    this.fields = attrs.fields;
	    this.pipeline = attrs.pipeline;
	  };
	
	  /**
	   * A result contains details of a document matching a search query.
	   * @typedef {Object} lunr.Index~Result
	   * @property {string} ref - The reference of the document this result represents.
	   * @property {number} score - A number between 0 and 1 representing how similar this document is to the query.
	   * @property {lunr.MatchData} matchData - Contains metadata about this match including which term(s) caused the match.
	   */
	
	  /**
	   * Although lunr provides the ability to create queries using lunr.Query, it also provides a simple
	   * query language which itself is parsed into an instance of lunr.Query.
	   *
	   * For programmatically building queries it is advised to directly use lunr.Query, the query language
	   * is best used for human entered text rather than program generated text.
	   *
	   * At its simplest queries can just be a single term, e.g. `hello`, multiple terms are also supported
	   * and will be combined with OR, e.g `hello world` will match documents that contain either 'hello'
	   * or 'world', though those that contain both will rank higher in the results.
	   *
	   * Wildcards can be included in terms to match one or more unspecified characters, these wildcards can
	   * be inserted anywhere within the term, and more than one wildcard can exist in a single term. Adding
	   * wildcards will increase the number of documents that will be found but can also have a negative
	   * impact on query performance, especially with wildcards at the beginning of a term.
	   *
	   * Terms can be restricted to specific fields, e.g. `title:hello`, only documents with the term
	   * hello in the title field will match this query. Using a field not present in the index will lead
	   * to an error being thrown.
	   *
	   * Modifiers can also be added to terms, lunr supports edit distance and boost modifiers on terms. A term
	   * boost will make documents matching that term score higher, e.g. `foo^5`. Edit distance is also supported
	   * to provide fuzzy matching, e.g. 'hello~2' will match documents with hello with an edit distance of 2.
	   * Avoid large values for edit distance to improve query performance.
	   *
	   * To escape special characters the backslash character '\' can be used, this allows searches to include
	   * characters that would normally be considered modifiers, e.g. `foo\~2` will search for a term "foo~2" instead
	   * of attempting to apply a boost of 2 to the search term "foo".
	   *
	   * @typedef {string} lunr.Index~QueryString
	   * @example <caption>Simple single term query</caption>
	   * hello
	   * @example <caption>Multiple term query</caption>
	   * hello world
	   * @example <caption>term scoped to a field</caption>
	   * title:hello
	   * @example <caption>term with a boost of 10</caption>
	   * hello^10
	   * @example <caption>term with an edit distance of 2</caption>
	   * hello~2
	   */
	
	  /**
	   * Performs a search against the index using lunr query syntax.
	   *
	   * Results will be returned sorted by their score, the most relevant results
	   * will be returned first.
	   *
	   * For more programmatic querying use lunr.Index#query.
	   *
	   * @param {lunr.Index~QueryString} queryString - A string containing a lunr query.
	   * @throws {lunr.QueryParseError} If the passed query string cannot be parsed.
	   * @returns {lunr.Index~Result[]}
	   */
	  lunr.Index.prototype.search = function (queryString) {
	    return this.query(function (query) {
	      var parser = new lunr.QueryParser(queryString, query);
	      parser.parse();
	    });
	  };
	
	  /**
	   * A query builder callback provides a query object to be used to express
	   * the query to perform on the index.
	   *
	   * @callback lunr.Index~queryBuilder
	   * @param {lunr.Query} query - The query object to build up.
	   * @this lunr.Query
	   */
	
	  /**
	   * Performs a query against the index using the yielded lunr.Query object.
	   *
	   * If performing programmatic queries against the index, this method is preferred
	   * over lunr.Index#search so as to avoid the additional query parsing overhead.
	   *
	   * A query object is yielded to the supplied function which should be used to
	   * express the query to be run against the index.
	   *
	   * Note that although this function takes a callback parameter it is _not_ an
	   * asynchronous operation, the callback is just yielded a query object to be
	   * customized.
	   *
	   * @param {lunr.Index~queryBuilder} fn - A function that is used to build the query.
	   * @returns {lunr.Index~Result[]}
	   */
	  lunr.Index.prototype.query = function (fn) {
	    // for each query clause
	    // * process terms
	    // * expand terms from token set
	    // * find matching documents and metadata
	    // * get document vectors
	    // * score documents
	
	    var query = new lunr.Query(this.fields),
	        matchingFields = Object.create(null),
	        queryVectors = Object.create(null),
	        termFieldCache = Object.create(null);
	
	    fn.call(query, query);
	
	    for (var i = 0; i < query.clauses.length; i++) {
	      /*
	       * Unless the pipeline has been disabled for this term, which is
	       * the case for terms with wildcards, we need to pass the clause
	       * term through the search pipeline. A pipeline returns an array
	       * of processed terms. Pipeline functions may expand the passed
	       * term, which means we may end up performing multiple index lookups
	       * for a single query term.
	       */
	      var clause = query.clauses[i],
	          terms = null;
	
	      if (clause.usePipeline) {
	        terms = this.pipeline.runString(clause.term);
	      } else {
	        terms = [clause.term];
	      }
	
	      for (var m = 0; m < terms.length; m++) {
	        var term = terms[m];
	
	        /*
	         * Each term returned from the pipeline needs to use the same query
	         * clause object, e.g. the same boost and or edit distance. The
	         * simplest way to do this is to re-use the clause object but mutate
	         * its term property.
	         */
	        clause.term = term;
	
	        /*
	         * From the term in the clause we create a token set which will then
	         * be used to intersect the indexes token set to get a list of terms
	         * to lookup in the inverted index
	         */
	        var termTokenSet = lunr.TokenSet.fromClause(clause),
	            expandedTerms = this.tokenSet.intersect(termTokenSet).toArray();
	
	        for (var j = 0; j < expandedTerms.length; j++) {
	          /*
	           * For each term get the posting and termIndex, this is required for
	           * building the query vector.
	           */
	          var expandedTerm = expandedTerms[j],
	              posting = this.invertedIndex[expandedTerm],
	              termIndex = posting._index;
	
	          for (var k = 0; k < clause.fields.length; k++) {
	            /*
	             * For each field that this query term is scoped by (by default
	             * all fields are in scope) we need to get all the document refs
	             * that have this term in that field.
	             *
	             * The posting is the entry in the invertedIndex for the matching
	             * term from above.
	             */
	            var field = clause.fields[k],
	                fieldPosting = posting[field],
	                matchingDocumentRefs = Object.keys(fieldPosting),
	                termField = expandedTerm + "/" + field;
	
	            /*
	             * To support field level boosts a query vector is created per
	             * field. This vector is populated using the termIndex found for
	             * the term and a unit value with the appropriate boost applied.
	             *
	             * If the query vector for this field does not exist yet it needs
	             * to be created.
	             */
	            if (queryVectors[field] === undefined) {
	              queryVectors[field] = new lunr.Vector();
	            }
	
	            /*
	             * Using upsert because there could already be an entry in the vector
	             * for the term we are working with. In that case we just add the scores
	             * together.
	             */
	            queryVectors[field].upsert(termIndex, 1 * clause.boost, function (a, b) {
	              return a + b;
	            });
	
	            /**
	             * If we've already seen this term, field combo then we've already collected
	             * the matching documents and metadata, no need to go through all that again
	             */
	            if (termFieldCache[termField]) {
	              continue;
	            }
	
	            for (var l = 0; l < matchingDocumentRefs.length; l++) {
	              /*
	               * All metadata for this term/field/document triple
	               * are then extracted and collected into an instance
	               * of lunr.MatchData ready to be returned in the query
	               * results
	               */
	              var matchingDocumentRef = matchingDocumentRefs[l],
	                  matchingFieldRef = new lunr.FieldRef(matchingDocumentRef, field),
	                  metadata = fieldPosting[matchingDocumentRef],
	                  fieldMatch;
	
	              if ((fieldMatch = matchingFields[matchingFieldRef]) === undefined) {
	                matchingFields[matchingFieldRef] = new lunr.MatchData(expandedTerm, field, metadata);
	              } else {
	                fieldMatch.add(expandedTerm, field, metadata);
	              }
	            }
	
	            termFieldCache[termField] = true;
	          }
	        }
	      }
	    }
	
	    var matchingFieldRefs = Object.keys(matchingFields),
	        results = [],
	        matches = Object.create(null);
	
	    for (var i = 0; i < matchingFieldRefs.length; i++) {
	      /*
	       * Currently we have document fields that match the query, but we
	       * need to return documents. The matchData and scores are combined
	       * from multiple fields belonging to the same document.
	       *
	       * Scores are calculated by field, using the query vectors created
	       * above, and combined into a final document score using addition.
	       */
	      var fieldRef = lunr.FieldRef.fromString(matchingFieldRefs[i]),
	          docRef = fieldRef.docRef,
	          fieldVector = this.fieldVectors[fieldRef],
	          score = queryVectors[fieldRef.fieldName].similarity(fieldVector),
	          docMatch;
	
	      if ((docMatch = matches[docRef]) !== undefined) {
	        docMatch.score += score;
	        docMatch.matchData.combine(matchingFields[fieldRef]);
	      } else {
	        var match = {
	          ref: docRef,
	          score: score,
	          matchData: matchingFields[fieldRef]
	        };
	        matches[docRef] = match;
	        results.push(match);
	      }
	    }
	
	    /*
	     * Sort the results objects by score, highest first.
	     */
	    return results.sort(function (a, b) {
	      return b.score - a.score;
	    });
	  };
	
	  /**
	   * Prepares the index for JSON serialization.
	   *
	   * The schema for this JSON blob will be described in a
	   * separate JSON schema file.
	   *
	   * @returns {Object}
	   */
	  lunr.Index.prototype.toJSON = function () {
	    var invertedIndex = Object.keys(this.invertedIndex).sort().map(function (term) {
	      return [term, this.invertedIndex[term]];
	    }, this);
	
	    var fieldVectors = Object.keys(this.fieldVectors).map(function (ref) {
	      return [ref, this.fieldVectors[ref].toJSON()];
	    }, this);
	
	    return {
	      version: lunr.version,
	      fields: this.fields,
	      fieldVectors: fieldVectors,
	      invertedIndex: invertedIndex,
	      pipeline: this.pipeline.toJSON()
	    };
	  };
	
	  /**
	   * Loads a previously serialized lunr.Index
	   *
	   * @param {Object} serializedIndex - A previously serialized lunr.Index
	   * @returns {lunr.Index}
	   */
	  lunr.Index.load = function (serializedIndex) {
	    var attrs = {},
	        fieldVectors = {},
	        serializedVectors = serializedIndex.fieldVectors,
	        invertedIndex = {},
	        serializedInvertedIndex = serializedIndex.invertedIndex,
	        tokenSetBuilder = new lunr.TokenSet.Builder(),
	        pipeline = lunr.Pipeline.load(serializedIndex.pipeline);
	
	    if (serializedIndex.version != lunr.version) {
	      lunr.utils.warn("Version mismatch when loading serialised index. Current version of lunr '" + lunr.version + "' does not match serialized index '" + serializedIndex.version + "'");
	    }
	
	    for (var i = 0; i < serializedVectors.length; i++) {
	      var tuple = serializedVectors[i],
	          ref = tuple[0],
	          elements = tuple[1];
	
	      fieldVectors[ref] = new lunr.Vector(elements);
	    }
	
	    for (var i = 0; i < serializedInvertedIndex.length; i++) {
	      var tuple = serializedInvertedIndex[i],
	          term = tuple[0],
	          posting = tuple[1];
	
	      tokenSetBuilder.insert(term);
	      invertedIndex[term] = posting;
	    }
	
	    tokenSetBuilder.finish();
	
	    attrs.fields = serializedIndex.fields;
	
	    attrs.fieldVectors = fieldVectors;
	    attrs.invertedIndex = invertedIndex;
	    attrs.tokenSet = tokenSetBuilder.root;
	    attrs.pipeline = pipeline;
	
	    return new lunr.Index(attrs);
	  };
	  /*!
	   * lunr.Builder
	   * Copyright (C) 2018 Oliver Nightingale
	   */
	
	  /**
	   * lunr.Builder performs indexing on a set of documents and
	   * returns instances of lunr.Index ready for querying.
	   *
	   * All configuration of the index is done via the builder, the
	   * fields to index, the document reference, the text processing
	   * pipeline and document scoring parameters are all set on the
	   * builder before indexing.
	   *
	   * @constructor
	   * @property {string} _ref - Internal reference to the document reference field.
	   * @property {string[]} _fields - Internal reference to the document fields to index.
	   * @property {object} invertedIndex - The inverted index maps terms to document fields.
	   * @property {object} documentTermFrequencies - Keeps track of document term frequencies.
	   * @property {object} documentLengths - Keeps track of the length of documents added to the index.
	   * @property {lunr.tokenizer} tokenizer - Function for splitting strings into tokens for indexing.
	   * @property {lunr.Pipeline} pipeline - The pipeline performs text processing on tokens before indexing.
	   * @property {lunr.Pipeline} searchPipeline - A pipeline for processing search terms before querying the index.
	   * @property {number} documentCount - Keeps track of the total number of documents indexed.
	   * @property {number} _b - A parameter to control field length normalization, setting this to 0 disabled normalization, 1 fully normalizes field lengths, the default value is 0.75.
	   * @property {number} _k1 - A parameter to control how quickly an increase in term frequency results in term frequency saturation, the default value is 1.2.
	   * @property {number} termIndex - A counter incremented for each unique term, used to identify a terms position in the vector space.
	   * @property {array} metadataWhitelist - A list of metadata keys that have been whitelisted for entry in the index.
	   */
	  lunr.Builder = function () {
	    this._ref = "id";
	    this._fields = [];
	    this.invertedIndex = Object.create(null);
	    this.fieldTermFrequencies = {};
	    this.fieldLengths = {};
	    this.tokenizer = lunr.tokenizer;
	    this.pipeline = new lunr.Pipeline();
	    this.searchPipeline = new lunr.Pipeline();
	    this.documentCount = 0;
	    this._b = 0.75;
	    this._k1 = 1.2;
	    this.termIndex = 0;
	    this.metadataWhitelist = [];
	  };
	
	  /**
	   * Sets the document field used as the document reference. Every document must have this field.
	   * The type of this field in the document should be a string, if it is not a string it will be
	   * coerced into a string by calling toString.
	   *
	   * The default ref is 'id'.
	   *
	   * The ref should _not_ be changed during indexing, it should be set before any documents are
	   * added to the index. Changing it during indexing can lead to inconsistent results.
	   *
	   * @param {string} ref - The name of the reference field in the document.
	   */
	  lunr.Builder.prototype.ref = function (ref) {
	    this._ref = ref;
	  };
	
	  /**
	   * Adds a field to the list of document fields that will be indexed. Every document being
	   * indexed should have this field. Null values for this field in indexed documents will
	   * not cause errors but will limit the chance of that document being retrieved by searches.
	   *
	   * All fields should be added before adding documents to the index. Adding fields after
	   * a document has been indexed will have no effect on already indexed documents.
	   *
	   * @param {string} field - The name of a field to index in all documents.
	   */
	  lunr.Builder.prototype.field = function (field) {
	    this._fields.push(field);
	  };
	
	  /**
	   * A parameter to tune the amount of field length normalisation that is applied when
	   * calculating relevance scores. A value of 0 will completely disable any normalisation
	   * and a value of 1 will fully normalise field lengths. The default is 0.75. Values of b
	   * will be clamped to the range 0 - 1.
	   *
	   * @param {number} number - The value to set for this tuning parameter.
	   */
	  lunr.Builder.prototype.b = function (number) {
	    if (number < 0) {
	      this._b = 0;
	    } else if (number > 1) {
	      this._b = 1;
	    } else {
	      this._b = number;
	    }
	  };
	
	  /**
	   * A parameter that controls the speed at which a rise in term frequency results in term
	   * frequency saturation. The default value is 1.2. Setting this to a higher value will give
	   * slower saturation levels, a lower value will result in quicker saturation.
	   *
	   * @param {number} number - The value to set for this tuning parameter.
	   */
	  lunr.Builder.prototype.k1 = function (number) {
	    this._k1 = number;
	  };
	
	  /**
	   * Adds a document to the index.
	   *
	   * Before adding fields to the index the index should have been fully setup, with the document
	   * ref and all fields to index already having been specified.
	   *
	   * The document must have a field name as specified by the ref (by default this is 'id') and
	   * it should have all fields defined for indexing, though null or undefined values will not
	   * cause errors.
	   *
	   * @param {object} doc - The document to add to the index.
	   */
	  lunr.Builder.prototype.add = function (doc) {
	    var docRef = doc[this._ref];
	
	    this.documentCount += 1;
	
	    for (var i = 0; i < this._fields.length; i++) {
	      var fieldName = this._fields[i],
	          field = doc[fieldName],
	          tokens = this.tokenizer(field),
	          terms = this.pipeline.run(tokens),
	          fieldRef = new lunr.FieldRef(docRef, fieldName),
	          fieldTerms = Object.create(null);
	
	      this.fieldTermFrequencies[fieldRef] = fieldTerms;
	      this.fieldLengths[fieldRef] = 0;
	
	      // store the length of this field for this document
	      this.fieldLengths[fieldRef] += terms.length;
	
	      // calculate term frequencies for this field
	      for (var j = 0; j < terms.length; j++) {
	        var term = terms[j];
	
	        if (fieldTerms[term] == undefined) {
	          fieldTerms[term] = 0;
	        }
	
	        fieldTerms[term] += 1;
	
	        // add to inverted index
	        // create an initial posting if one doesn't exist
	        if (this.invertedIndex[term] == undefined) {
	          var posting = Object.create(null);
	          posting["_index"] = this.termIndex;
	          this.termIndex += 1;
	
	          for (var k = 0; k < this._fields.length; k++) {
	            posting[this._fields[k]] = Object.create(null);
	          }
	
	          this.invertedIndex[term] = posting;
	        }
	
	        // add an entry for this term/fieldName/docRef to the invertedIndex
	        if (this.invertedIndex[term][fieldName][docRef] == undefined) {
	          this.invertedIndex[term][fieldName][docRef] = Object.create(null);
	        }
	
	        // store all whitelisted metadata about this token in the
	        // inverted index
	        for (var l = 0; l < this.metadataWhitelist.length; l++) {
	          var metadataKey = this.metadataWhitelist[l],
	              metadata = term.metadata[metadataKey];
	
	          if (this.invertedIndex[term][fieldName][docRef][metadataKey] == undefined) {
	            this.invertedIndex[term][fieldName][docRef][metadataKey] = [];
	          }
	
	          this.invertedIndex[term][fieldName][docRef][metadataKey].push(metadata);
	        }
	      }
	    }
	  };
	
	  /**
	   * Calculates the average document length for this index
	   *
	   * @private
	   */
	  lunr.Builder.prototype.calculateAverageFieldLengths = function () {
	
	    var fieldRefs = Object.keys(this.fieldLengths),
	        numberOfFields = fieldRefs.length,
	        accumulator = {},
	        documentsWithField = {};
	
	    for (var i = 0; i < numberOfFields; i++) {
	      var fieldRef = lunr.FieldRef.fromString(fieldRefs[i]),
	          field = fieldRef.fieldName;
	
	      documentsWithField[field] || (documentsWithField[field] = 0);
	      documentsWithField[field] += 1;
	
	      accumulator[field] || (accumulator[field] = 0);
	      accumulator[field] += this.fieldLengths[fieldRef];
	    }
	
	    for (var i = 0; i < this._fields.length; i++) {
	      var field = this._fields[i];
	      accumulator[field] = accumulator[field] / documentsWithField[field];
	    }
	
	    this.averageFieldLength = accumulator;
	  };
	
	  /**
	   * Builds a vector space model of every document using lunr.Vector
	   *
	   * @private
	   */
	  lunr.Builder.prototype.createFieldVectors = function () {
	    var fieldVectors = {},
	        fieldRefs = Object.keys(this.fieldTermFrequencies),
	        fieldRefsLength = fieldRefs.length,
	        termIdfCache = Object.create(null);
	
	    for (var i = 0; i < fieldRefsLength; i++) {
	      var fieldRef = lunr.FieldRef.fromString(fieldRefs[i]),
	          field = fieldRef.fieldName,
	          fieldLength = this.fieldLengths[fieldRef],
	          fieldVector = new lunr.Vector(),
	          termFrequencies = this.fieldTermFrequencies[fieldRef],
	          terms = Object.keys(termFrequencies),
	          termsLength = terms.length;
	
	      for (var j = 0; j < termsLength; j++) {
	        var term = terms[j],
	            tf = termFrequencies[term],
	            termIndex = this.invertedIndex[term]._index,
	            idf,
	            score,
	            scoreWithPrecision;
	
	        if (termIdfCache[term] === undefined) {
	          idf = lunr.idf(this.invertedIndex[term], this.documentCount);
	          termIdfCache[term] = idf;
	        } else {
	          idf = termIdfCache[term];
	        }
	
	        score = idf * ((this._k1 + 1) * tf) / (this._k1 * (1 - this._b + this._b * (fieldLength / this.averageFieldLength[field])) + tf);
	        scoreWithPrecision = Math.round(score * 1000) / 1000;
	        // Converts 1.23456789 to 1.234.
	        // Reducing the precision so that the vectors take up less
	        // space when serialised. Doing it now so that they behave
	        // the same before and after serialisation. Also, this is
	        // the fastest approach to reducing a number's precision in
	        // JavaScript.
	
	        fieldVector.insert(termIndex, scoreWithPrecision);
	      }
	
	      fieldVectors[fieldRef] = fieldVector;
	    }
	
	    this.fieldVectors = fieldVectors;
	  };
	
	  /**
	   * Creates a token set of all tokens in the index using lunr.TokenSet
	   *
	   * @private
	   */
	  lunr.Builder.prototype.createTokenSet = function () {
	    this.tokenSet = lunr.TokenSet.fromArray(Object.keys(this.invertedIndex).sort());
	  };
	
	  /**
	   * Builds the index, creating an instance of lunr.Index.
	   *
	   * This completes the indexing process and should only be called
	   * once all documents have been added to the index.
	   *
	   * @returns {lunr.Index}
	   */
	  lunr.Builder.prototype.build = function () {
	    this.calculateAverageFieldLengths();
	    this.createFieldVectors();
	    this.createTokenSet();
	
	    return new lunr.Index({
	      invertedIndex: this.invertedIndex,
	      fieldVectors: this.fieldVectors,
	      tokenSet: this.tokenSet,
	      fields: this._fields,
	      pipeline: this.searchPipeline
	    });
	  };
	
	  /**
	   * Applies a plugin to the index builder.
	   *
	   * A plugin is a function that is called with the index builder as its context.
	   * Plugins can be used to customise or extend the behaviour of the index
	   * in some way. A plugin is just a function, that encapsulated the custom
	   * behaviour that should be applied when building the index.
	   *
	   * The plugin function will be called with the index builder as its argument, additional
	   * arguments can also be passed when calling use. The function will be called
	   * with the index builder as its context.
	   *
	   * @param {Function} plugin The plugin to apply.
	   */
	  lunr.Builder.prototype.use = function (fn) {
	    var args = Array.prototype.slice.call(arguments, 1);
	    args.unshift(this);
	    fn.apply(this, args);
	  };
	  /**
	   * Contains and collects metadata about a matching document.
	   * A single instance of lunr.MatchData is returned as part of every
	   * lunr.Index~Result.
	   *
	   * @constructor
	   * @param {string} term - The term this match data is associated with
	   * @param {string} field - The field in which the term was found
	   * @param {object} metadata - The metadata recorded about this term in this field
	   * @property {object} metadata - A cloned collection of metadata associated with this document.
	   * @see {@link lunr.Index~Result}
	   */
	  lunr.MatchData = function (term, field, metadata) {
	    var clonedMetadata = Object.create(null),
	        metadataKeys = Object.keys(metadata);
	
	    // Cloning the metadata to prevent the original
	    // being mutated during match data combination.
	    // Metadata is kept in an array within the inverted
	    // index so cloning the data can be done with
	    // Array#slice
	    for (var i = 0; i < metadataKeys.length; i++) {
	      var key = metadataKeys[i];
	      clonedMetadata[key] = metadata[key].slice();
	    }
	
	    this.metadata = Object.create(null);
	    this.metadata[term] = Object.create(null);
	    this.metadata[term][field] = clonedMetadata;
	  };
	
	  /**
	   * An instance of lunr.MatchData will be created for every term that matches a
	   * document. However only one instance is required in a lunr.Index~Result. This
	   * method combines metadata from another instance of lunr.MatchData with this
	   * objects metadata.
	   *
	   * @param {lunr.MatchData} otherMatchData - Another instance of match data to merge with this one.
	   * @see {@link lunr.Index~Result}
	   */
	  lunr.MatchData.prototype.combine = function (otherMatchData) {
	    var terms = Object.keys(otherMatchData.metadata);
	
	    for (var i = 0; i < terms.length; i++) {
	      var term = terms[i],
	          fields = Object.keys(otherMatchData.metadata[term]);
	
	      if (this.metadata[term] == undefined) {
	        this.metadata[term] = Object.create(null);
	      }
	
	      for (var j = 0; j < fields.length; j++) {
	        var field = fields[j],
	            keys = Object.keys(otherMatchData.metadata[term][field]);
	
	        if (this.metadata[term][field] == undefined) {
	          this.metadata[term][field] = Object.create(null);
	        }
	
	        for (var k = 0; k < keys.length; k++) {
	          var key = keys[k];
	
	          if (this.metadata[term][field][key] == undefined) {
	            this.metadata[term][field][key] = otherMatchData.metadata[term][field][key];
	          } else {
	            this.metadata[term][field][key] = this.metadata[term][field][key].concat(otherMatchData.metadata[term][field][key]);
	          }
	        }
	      }
	    }
	  };
	
	  /**
	   * Add metadata for a term/field pair to this instance of match data.
	   *
	   * @param {string} term - The term this match data is associated with
	   * @param {string} field - The field in which the term was found
	   * @param {object} metadata - The metadata recorded about this term in this field
	   */
	  lunr.MatchData.prototype.add = function (term, field, metadata) {
	    if (!(term in this.metadata)) {
	      this.metadata[term] = Object.create(null);
	      this.metadata[term][field] = metadata;
	      return;
	    }
	
	    if (!(field in this.metadata[term])) {
	      this.metadata[term][field] = metadata;
	      return;
	    }
	
	    var metadataKeys = Object.keys(metadata);
	
	    for (var i = 0; i < metadataKeys.length; i++) {
	      var key = metadataKeys[i];
	
	      if (key in this.metadata[term][field]) {
	        this.metadata[term][field][key] = this.metadata[term][field][key].concat(metadata[key]);
	      } else {
	        this.metadata[term][field][key] = metadata[key];
	      }
	    }
	  };
	  /**
	   * A lunr.Query provides a programmatic way of defining queries to be performed
	   * against a {@link lunr.Index}.
	   *
	   * Prefer constructing a lunr.Query using the {@link lunr.Index#query} method
	   * so the query object is pre-initialized with the right index fields.
	   *
	   * @constructor
	   * @property {lunr.Query~Clause[]} clauses - An array of query clauses.
	   * @property {string[]} allFields - An array of all available fields in a lunr.Index.
	   */
	  lunr.Query = function (allFields) {
	    this.clauses = [];
	    this.allFields = allFields;
	  };
	
	  /**
	   * Constants for indicating what kind of automatic wildcard insertion will be used when constructing a query clause.
	   *
	   * This allows wildcards to be added to the beginning and end of a term without having to manually do any string
	   * concatenation.
	   *
	   * The wildcard constants can be bitwise combined to select both leading and trailing wildcards.
	   *
	   * @constant
	   * @default
	   * @property {number} wildcard.NONE - The term will have no wildcards inserted, this is the default behaviour
	   * @property {number} wildcard.LEADING - Prepend the term with a wildcard, unless a leading wildcard already exists
	   * @property {number} wildcard.TRAILING - Append a wildcard to the term, unless a trailing wildcard already exists
	   * @see lunr.Query~Clause
	   * @see lunr.Query#clause
	   * @see lunr.Query#term
	   * @example <caption>query term with trailing wildcard</caption>
	   * query.term('foo', { wildcard: lunr.Query.wildcard.TRAILING })
	   * @example <caption>query term with leading and trailing wildcard</caption>
	   * query.term('foo', {
	   *   wildcard: lunr.Query.wildcard.LEADING | lunr.Query.wildcard.TRAILING
	   * })
	   */
	  lunr.Query.wildcard = new String("*");
	  lunr.Query.wildcard.NONE = 0;
	  lunr.Query.wildcard.LEADING = 1;
	  lunr.Query.wildcard.TRAILING = 2;
	
	  /**
	   * A single clause in a {@link lunr.Query} contains a term and details on how to
	   * match that term against a {@link lunr.Index}.
	   *
	   * @typedef {Object} lunr.Query~Clause
	   * @property {string[]} fields - The fields in an index this clause should be matched against.
	   * @property {number} [boost=1] - Any boost that should be applied when matching this clause.
	   * @property {number} [editDistance] - Whether the term should have fuzzy matching applied, and how fuzzy the match should be.
	   * @property {boolean} [usePipeline] - Whether the term should be passed through the search pipeline.
	   * @property {number} [wildcard=0] - Whether the term should have wildcards appended or prepended.
	   */
	
	  /**
	   * Adds a {@link lunr.Query~Clause} to this query.
	   *
	   * Unless the clause contains the fields to be matched all fields will be matched. In addition
	   * a default boost of 1 is applied to the clause.
	   *
	   * @param {lunr.Query~Clause} clause - The clause to add to this query.
	   * @see lunr.Query~Clause
	   * @returns {lunr.Query}
	   */
	  lunr.Query.prototype.clause = function (clause) {
	    if (!('fields' in clause)) {
	      clause.fields = this.allFields;
	    }
	
	    if (!('boost' in clause)) {
	      clause.boost = 1;
	    }
	
	    if (!('usePipeline' in clause)) {
	      clause.usePipeline = true;
	    }
	
	    if (!('wildcard' in clause)) {
	      clause.wildcard = lunr.Query.wildcard.NONE;
	    }
	
	    if (clause.wildcard & lunr.Query.wildcard.LEADING && clause.term.charAt(0) != lunr.Query.wildcard) {
	      clause.term = "*" + clause.term;
	    }
	
	    if (clause.wildcard & lunr.Query.wildcard.TRAILING && clause.term.slice(-1) != lunr.Query.wildcard) {
	      clause.term = "" + clause.term + "*";
	    }
	
	    this.clauses.push(clause);
	
	    return this;
	  };
	
	  /**
	   * Adds a term to the current query, under the covers this will create a {@link lunr.Query~Clause}
	   * to the list of clauses that make up this query.
	   *
	   * @param {string} term - The term to add to the query.
	   * @param {Object} [options] - Any additional properties to add to the query clause.
	   * @returns {lunr.Query}
	   * @see lunr.Query#clause
	   * @see lunr.Query~Clause
	   * @example <caption>adding a single term to a query</caption>
	   * query.term("foo")
	   * @example <caption>adding a single term to a query and specifying search fields, term boost and automatic trailing wildcard</caption>
	   * query.term("foo", {
	   *   fields: ["title"],
	   *   boost: 10,
	   *   wildcard: lunr.Query.wildcard.TRAILING
	   * })
	   */
	  lunr.Query.prototype.term = function (term, options) {
	    var clause = options || {};
	    clause.term = term;
	
	    this.clause(clause);
	
	    return this;
	  };
	  lunr.QueryParseError = function (message, start, end) {
	    this.name = "QueryParseError";
	    this.message = message;
	    this.start = start;
	    this.end = end;
	  };
	
	  lunr.QueryParseError.prototype = new Error();
	  lunr.QueryLexer = function (str) {
	    this.lexemes = [];
	    this.str = str;
	    this.length = str.length;
	    this.pos = 0;
	    this.start = 0;
	    this.escapeCharPositions = [];
	  };
	
	  lunr.QueryLexer.prototype.run = function () {
	    var state = lunr.QueryLexer.lexText;
	
	    while (state) {
	      state = state(this);
	    }
	  };
	
	  lunr.QueryLexer.prototype.sliceString = function () {
	    var subSlices = [],
	        sliceStart = this.start,
	        sliceEnd = this.pos;
	
	    for (var i = 0; i < this.escapeCharPositions.length; i++) {
	      sliceEnd = this.escapeCharPositions[i];
	      subSlices.push(this.str.slice(sliceStart, sliceEnd));
	      sliceStart = sliceEnd + 1;
	    }
	
	    subSlices.push(this.str.slice(sliceStart, this.pos));
	    this.escapeCharPositions.length = 0;
	
	    return subSlices.join('');
	  };
	
	  lunr.QueryLexer.prototype.emit = function (type) {
	    this.lexemes.push({
	      type: type,
	      str: this.sliceString(),
	      start: this.start,
	      end: this.pos
	    });
	
	    this.start = this.pos;
	  };
	
	  lunr.QueryLexer.prototype.escapeCharacter = function () {
	    this.escapeCharPositions.push(this.pos - 1);
	    this.pos += 1;
	  };
	
	  lunr.QueryLexer.prototype.next = function () {
	    if (this.pos >= this.length) {
	      return lunr.QueryLexer.EOS;
	    }
	
	    var char = this.str.charAt(this.pos);
	    this.pos += 1;
	    return char;
	  };
	
	  lunr.QueryLexer.prototype.width = function () {
	    return this.pos - this.start;
	  };
	
	  lunr.QueryLexer.prototype.ignore = function () {
	    if (this.start == this.pos) {
	      this.pos += 1;
	    }
	
	    this.start = this.pos;
	  };
	
	  lunr.QueryLexer.prototype.backup = function () {
	    this.pos -= 1;
	  };
	
	  lunr.QueryLexer.prototype.acceptDigitRun = function () {
	    var char, charCode;
	
	    do {
	      char = this.next();
	      charCode = char.charCodeAt(0);
	    } while (charCode > 47 && charCode < 58);
	
	    if (char != lunr.QueryLexer.EOS) {
	      this.backup();
	    }
	  };
	
	  lunr.QueryLexer.prototype.more = function () {
	    return this.pos < this.length;
	  };
	
	  lunr.QueryLexer.EOS = 'EOS';
	  lunr.QueryLexer.FIELD = 'FIELD';
	  lunr.QueryLexer.TERM = 'TERM';
	  lunr.QueryLexer.EDIT_DISTANCE = 'EDIT_DISTANCE';
	  lunr.QueryLexer.BOOST = 'BOOST';
	
	  lunr.QueryLexer.lexField = function (lexer) {
	    lexer.backup();
	    lexer.emit(lunr.QueryLexer.FIELD);
	    lexer.ignore();
	    return lunr.QueryLexer.lexText;
	  };
	
	  lunr.QueryLexer.lexTerm = function (lexer) {
	    if (lexer.width() > 1) {
	      lexer.backup();
	      lexer.emit(lunr.QueryLexer.TERM);
	    }
	
	    lexer.ignore();
	
	    if (lexer.more()) {
	      return lunr.QueryLexer.lexText;
	    }
	  };
	
	  lunr.QueryLexer.lexEditDistance = function (lexer) {
	    lexer.ignore();
	    lexer.acceptDigitRun();
	    lexer.emit(lunr.QueryLexer.EDIT_DISTANCE);
	    return lunr.QueryLexer.lexText;
	  };
	
	  lunr.QueryLexer.lexBoost = function (lexer) {
	    lexer.ignore();
	    lexer.acceptDigitRun();
	    lexer.emit(lunr.QueryLexer.BOOST);
	    return lunr.QueryLexer.lexText;
	  };
	
	  lunr.QueryLexer.lexEOS = function (lexer) {
	    if (lexer.width() > 0) {
	      lexer.emit(lunr.QueryLexer.TERM);
	    }
	  };
	
	  // This matches the separator used when tokenising fields
	  // within a document. These should match otherwise it is
	  // not possible to search for some tokens within a document.
	  //
	  // It is possible for the user to change the separator on the
	  // tokenizer so it _might_ clash with any other of the special
	  // characters already used within the search string, e.g. :.
	  //
	  // This means that it is possible to change the separator in
	  // such a way that makes some words unsearchable using a search
	  // string.
	  lunr.QueryLexer.termSeparator = lunr.tokenizer.separator;
	
	  lunr.QueryLexer.lexText = function (lexer) {
	    while (true) {
	      var char = lexer.next();
	
	      if (char == lunr.QueryLexer.EOS) {
	        return lunr.QueryLexer.lexEOS;
	      }
	
	      // Escape character is '\'
	      if (char.charCodeAt(0) == 92) {
	        lexer.escapeCharacter();
	        continue;
	      }
	
	      if (char == ":") {
	        return lunr.QueryLexer.lexField;
	      }
	
	      if (char == "~") {
	        lexer.backup();
	        if (lexer.width() > 0) {
	          lexer.emit(lunr.QueryLexer.TERM);
	        }
	        return lunr.QueryLexer.lexEditDistance;
	      }
	
	      if (char == "^") {
	        lexer.backup();
	        if (lexer.width() > 0) {
	          lexer.emit(lunr.QueryLexer.TERM);
	        }
	        return lunr.QueryLexer.lexBoost;
	      }
	
	      if (char.match(lunr.QueryLexer.termSeparator)) {
	        return lunr.QueryLexer.lexTerm;
	      }
	    }
	  };
	
	  lunr.QueryParser = function (str, query) {
	    this.lexer = new lunr.QueryLexer(str);
	    this.query = query;
	    this.currentClause = {};
	    this.lexemeIdx = 0;
	  };
	
	  lunr.QueryParser.prototype.parse = function () {
	    this.lexer.run();
	    this.lexemes = this.lexer.lexemes;
	
	    var state = lunr.QueryParser.parseFieldOrTerm;
	
	    while (state) {
	      state = state(this);
	    }
	
	    return this.query;
	  };
	
	  lunr.QueryParser.prototype.peekLexeme = function () {
	    return this.lexemes[this.lexemeIdx];
	  };
	
	  lunr.QueryParser.prototype.consumeLexeme = function () {
	    var lexeme = this.peekLexeme();
	    this.lexemeIdx += 1;
	    return lexeme;
	  };
	
	  lunr.QueryParser.prototype.nextClause = function () {
	    var completedClause = this.currentClause;
	    this.query.clause(completedClause);
	    this.currentClause = {};
	  };
	
	  lunr.QueryParser.parseFieldOrTerm = function (parser) {
	    var lexeme = parser.peekLexeme();
	
	    if (lexeme == undefined) {
	      return;
	    }
	
	    switch (lexeme.type) {
	      case lunr.QueryLexer.FIELD:
	        return lunr.QueryParser.parseField;
	      case lunr.QueryLexer.TERM:
	        return lunr.QueryParser.parseTerm;
	      default:
	        var errorMessage = "expected either a field or a term, found " + lexeme.type;
	
	        if (lexeme.str.length >= 1) {
	          errorMessage += " with value '" + lexeme.str + "'";
	        }
	
	        throw new lunr.QueryParseError(errorMessage, lexeme.start, lexeme.end);
	    }
	  };
	
	  lunr.QueryParser.parseField = function (parser) {
	    var lexeme = parser.consumeLexeme();
	
	    if (lexeme == undefined) {
	      return;
	    }
	
	    if (parser.query.allFields.indexOf(lexeme.str) == -1) {
	      var possibleFields = parser.query.allFields.map(function (f) {
	        return "'" + f + "'";
	      }).join(', '),
	          errorMessage = "unrecognised field '" + lexeme.str + "', possible fields: " + possibleFields;
	
	      throw new lunr.QueryParseError(errorMessage, lexeme.start, lexeme.end);
	    }
	
	    parser.currentClause.fields = [lexeme.str];
	
	    var nextLexeme = parser.peekLexeme();
	
	    if (nextLexeme == undefined) {
	      var errorMessage = "expecting term, found nothing";
	      throw new lunr.QueryParseError(errorMessage, lexeme.start, lexeme.end);
	    }
	
	    switch (nextLexeme.type) {
	      case lunr.QueryLexer.TERM:
	        return lunr.QueryParser.parseTerm;
	      default:
	        var errorMessage = "expecting term, found '" + nextLexeme.type + "'";
	        throw new lunr.QueryParseError(errorMessage, nextLexeme.start, nextLexeme.end);
	    }
	  };
	
	  lunr.QueryParser.parseTerm = function (parser) {
	    var lexeme = parser.consumeLexeme();
	
	    if (lexeme == undefined) {
	      return;
	    }
	
	    parser.currentClause.term = lexeme.str.toLowerCase();
	
	    if (lexeme.str.indexOf("*") != -1) {
	      parser.currentClause.usePipeline = false;
	    }
	
	    var nextLexeme = parser.peekLexeme();
	
	    if (nextLexeme == undefined) {
	      parser.nextClause();
	      return;
	    }
	
	    switch (nextLexeme.type) {
	      case lunr.QueryLexer.TERM:
	        parser.nextClause();
	        return lunr.QueryParser.parseTerm;
	      case lunr.QueryLexer.FIELD:
	        parser.nextClause();
	        return lunr.QueryParser.parseField;
	      case lunr.QueryLexer.EDIT_DISTANCE:
	        return lunr.QueryParser.parseEditDistance;
	      case lunr.QueryLexer.BOOST:
	        return lunr.QueryParser.parseBoost;
	      default:
	        var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'";
	        throw new lunr.QueryParseError(errorMessage, nextLexeme.start, nextLexeme.end);
	    }
	  };
	
	  lunr.QueryParser.parseEditDistance = function (parser) {
	    var lexeme = parser.consumeLexeme();
	
	    if (lexeme == undefined) {
	      return;
	    }
	
	    var editDistance = parseInt(lexeme.str, 10);
	
	    if (isNaN(editDistance)) {
	      var errorMessage = "edit distance must be numeric";
	      throw new lunr.QueryParseError(errorMessage, lexeme.start, lexeme.end);
	    }
	
	    parser.currentClause.editDistance = editDistance;
	
	    var nextLexeme = parser.peekLexeme();
	
	    if (nextLexeme == undefined) {
	      parser.nextClause();
	      return;
	    }
	
	    switch (nextLexeme.type) {
	      case lunr.QueryLexer.TERM:
	        parser.nextClause();
	        return lunr.QueryParser.parseTerm;
	      case lunr.QueryLexer.FIELD:
	        parser.nextClause();
	        return lunr.QueryParser.parseField;
	      case lunr.QueryLexer.EDIT_DISTANCE:
	        return lunr.QueryParser.parseEditDistance;
	      case lunr.QueryLexer.BOOST:
	        return lunr.QueryParser.parseBoost;
	      default:
	        var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'";
	        throw new lunr.QueryParseError(errorMessage, nextLexeme.start, nextLexeme.end);
	    }
	  };
	
	  lunr.QueryParser.parseBoost = function (parser) {
	    var lexeme = parser.consumeLexeme();
	
	    if (lexeme == undefined) {
	      return;
	    }
	
	    var boost = parseInt(lexeme.str, 10);
	
	    if (isNaN(boost)) {
	      var errorMessage = "boost must be numeric";
	      throw new lunr.QueryParseError(errorMessage, lexeme.start, lexeme.end);
	    }
	
	    parser.currentClause.boost = boost;
	
	    var nextLexeme = parser.peekLexeme();
	
	    if (nextLexeme == undefined) {
	      parser.nextClause();
	      return;
	    }
	
	    switch (nextLexeme.type) {
	      case lunr.QueryLexer.TERM:
	        parser.nextClause();
	        return lunr.QueryParser.parseTerm;
	      case lunr.QueryLexer.FIELD:
	        parser.nextClause();
	        return lunr.QueryParser.parseField;
	      case lunr.QueryLexer.EDIT_DISTANCE:
	        return lunr.QueryParser.parseEditDistance;
	      case lunr.QueryLexer.BOOST:
	        return lunr.QueryParser.parseBoost;
	      default:
	        var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'";
	        throw new lunr.QueryParseError(errorMessage, nextLexeme.start, nextLexeme.end);
	    }
	  }
	
	  /**
	   * export the module via AMD, CommonJS or as a browser global
	   * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
	   */
	  ;(function (root, factory) {
	    if (true) {
	      // AMD. Register as an anonymous module.
	      !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if ((typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object') {
	      /**
	       * Node. Does not work with strict CommonJS, but
	       * only CommonJS-like enviroments that support module.exports,
	       * like Node.
	       */
	      module.exports = factory();
	    } else {
	      // Browser globals (root is window)
	      root.lunr = factory();
	    }
	  })(this, function () {
	    /**
	     * Just return a value to define the module export.
	     * This example returns an object, but the module
	     * can return a function as the exported value.
	     */
	    return lunr;
	  });
	})();

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/* global $ */
	var Base = function () {
	  function Base() {
	    _classCallCheck(this, Base);
	
	    this.base = {};
	    this.init();
	  }
	
	  _createClass(Base, [{
	    key: 'init',
	    value: function init() {
	      this.base = $('#database').data('peers');
	      document.getElementsByTagName('body')[0].removeChild(document.getElementById('database'));
	    }
	  }]);
	
	  return Base;
	}();
	
	exports.default = new Base();
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 6 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = document.documentElement.lang;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/*!
	 * Snowball JavaScript Library v0.3
	 * http://code.google.com/p/urim/
	 * http://snowball.tartarus.org/
	 *
	 * Copyright 2010, Oleg Mazko
	 * http://www.mozilla.org/MPL/
	 */
	
	/**
	 * export the module via AMD, CommonJS or as a browser global
	 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
	 */
	;(function (root, factory) {
	    if (true) {
	        // AMD. Register as an anonymous module.
	        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if ((typeof exports === 'undefined' ? 'undefined' : _typeof(exports)) === 'object') {
	        /**
	         * Node. Does not work with strict CommonJS, but
	         * only CommonJS-like environments that support module.exports,
	         * like Node.
	         */
	        module.exports = factory();
	    } else {
	        // Browser globals (root is window)
	        factory()(root.lunr);
	    }
	})(undefined, function () {
	    /**
	     * Just return a value to define the module export.
	     * This example returns an object, but the module
	     * can return a function as the exported value.
	     */
	    return function (lunr) {
	        /* provides utilities for the included stemmers */
	        lunr.stemmerSupport = {
	            Among: function Among(s, substring_i, result, method) {
	                this.toCharArray = function (s) {
	                    var sLength = s.length,
	                        charArr = new Array(sLength);
	                    for (var i = 0; i < sLength; i++) {
	                        charArr[i] = s.charCodeAt(i);
	                    }return charArr;
	                };
	
	                if (!s && s != "" || !substring_i && substring_i != 0 || !result) throw "Bad Among initialisation: s:" + s + ", substring_i: " + substring_i + ", result: " + result;
	                this.s_size = s.length;
	                this.s = this.toCharArray(s);
	                this.substring_i = substring_i;
	                this.result = result;
	                this.method = method;
	            },
	            SnowballProgram: function SnowballProgram() {
	                var current;
	                return {
	                    bra: 0,
	                    ket: 0,
	                    limit: 0,
	                    cursor: 0,
	                    limit_backward: 0,
	                    setCurrent: function setCurrent(word) {
	                        current = word;
	                        this.cursor = 0;
	                        this.limit = word.length;
	                        this.limit_backward = 0;
	                        this.bra = this.cursor;
	                        this.ket = this.limit;
	                    },
	                    getCurrent: function getCurrent() {
	                        var result = current;
	                        current = null;
	                        return result;
	                    },
	                    in_grouping: function in_grouping(s, min, max) {
	                        if (this.cursor < this.limit) {
	                            var ch = current.charCodeAt(this.cursor);
	                            if (ch <= max && ch >= min) {
	                                ch -= min;
	                                if (s[ch >> 3] & 0X1 << (ch & 0X7)) {
	                                    this.cursor++;
	                                    return true;
	                                }
	                            }
	                        }
	                        return false;
	                    },
	                    in_grouping_b: function in_grouping_b(s, min, max) {
	                        if (this.cursor > this.limit_backward) {
	                            var ch = current.charCodeAt(this.cursor - 1);
	                            if (ch <= max && ch >= min) {
	                                ch -= min;
	                                if (s[ch >> 3] & 0X1 << (ch & 0X7)) {
	                                    this.cursor--;
	                                    return true;
	                                }
	                            }
	                        }
	                        return false;
	                    },
	                    out_grouping: function out_grouping(s, min, max) {
	                        if (this.cursor < this.limit) {
	                            var ch = current.charCodeAt(this.cursor);
	                            if (ch > max || ch < min) {
	                                this.cursor++;
	                                return true;
	                            }
	                            ch -= min;
	                            if (!(s[ch >> 3] & 0X1 << (ch & 0X7))) {
	                                this.cursor++;
	                                return true;
	                            }
	                        }
	                        return false;
	                    },
	                    out_grouping_b: function out_grouping_b(s, min, max) {
	                        if (this.cursor > this.limit_backward) {
	                            var ch = current.charCodeAt(this.cursor - 1);
	                            if (ch > max || ch < min) {
	                                this.cursor--;
	                                return true;
	                            }
	                            ch -= min;
	                            if (!(s[ch >> 3] & 0X1 << (ch & 0X7))) {
	                                this.cursor--;
	                                return true;
	                            }
	                        }
	                        return false;
	                    },
	                    eq_s: function eq_s(s_size, s) {
	                        if (this.limit - this.cursor < s_size) return false;
	                        for (var i = 0; i < s_size; i++) {
	                            if (current.charCodeAt(this.cursor + i) != s.charCodeAt(i)) return false;
	                        }this.cursor += s_size;
	                        return true;
	                    },
	                    eq_s_b: function eq_s_b(s_size, s) {
	                        if (this.cursor - this.limit_backward < s_size) return false;
	                        for (var i = 0; i < s_size; i++) {
	                            if (current.charCodeAt(this.cursor - s_size + i) != s.charCodeAt(i)) return false;
	                        }this.cursor -= s_size;
	                        return true;
	                    },
	                    find_among: function find_among(v, v_size) {
	                        var i = 0,
	                            j = v_size,
	                            c = this.cursor,
	                            l = this.limit,
	                            common_i = 0,
	                            common_j = 0,
	                            first_key_inspected = false;
	                        while (true) {
	                            var k = i + (j - i >> 1),
	                                diff = 0,
	                                common = common_i < common_j ? common_i : common_j,
	                                w = v[k];
	                            for (var i2 = common; i2 < w.s_size; i2++) {
	                                if (c + common == l) {
	                                    diff = -1;
	                                    break;
	                                }
	                                diff = current.charCodeAt(c + common) - w.s[i2];
	                                if (diff) break;
	                                common++;
	                            }
	                            if (diff < 0) {
	                                j = k;
	                                common_j = common;
	                            } else {
	                                i = k;
	                                common_i = common;
	                            }
	                            if (j - i <= 1) {
	                                if (i > 0 || j == i || first_key_inspected) break;
	                                first_key_inspected = true;
	                            }
	                        }
	                        while (true) {
	                            var w = v[i];
	                            if (common_i >= w.s_size) {
	                                this.cursor = c + w.s_size;
	                                if (!w.method) return w.result;
	                                var res = w.method();
	                                this.cursor = c + w.s_size;
	                                if (res) return w.result;
	                            }
	                            i = w.substring_i;
	                            if (i < 0) return 0;
	                        }
	                    },
	                    find_among_b: function find_among_b(v, v_size) {
	                        var i = 0,
	                            j = v_size,
	                            c = this.cursor,
	                            lb = this.limit_backward,
	                            common_i = 0,
	                            common_j = 0,
	                            first_key_inspected = false;
	                        while (true) {
	                            var k = i + (j - i >> 1),
	                                diff = 0,
	                                common = common_i < common_j ? common_i : common_j,
	                                w = v[k];
	                            for (var i2 = w.s_size - 1 - common; i2 >= 0; i2--) {
	                                if (c - common == lb) {
	                                    diff = -1;
	                                    break;
	                                }
	                                diff = current.charCodeAt(c - 1 - common) - w.s[i2];
	                                if (diff) break;
	                                common++;
	                            }
	                            if (diff < 0) {
	                                j = k;
	                                common_j = common;
	                            } else {
	                                i = k;
	                                common_i = common;
	                            }
	                            if (j - i <= 1) {
	                                if (i > 0 || j == i || first_key_inspected) break;
	                                first_key_inspected = true;
	                            }
	                        }
	                        while (true) {
	                            var w = v[i];
	                            if (common_i >= w.s_size) {
	                                this.cursor = c - w.s_size;
	                                if (!w.method) return w.result;
	                                var res = w.method();
	                                this.cursor = c - w.s_size;
	                                if (res) return w.result;
	                            }
	                            i = w.substring_i;
	                            if (i < 0) return 0;
	                        }
	                    },
	                    replace_s: function replace_s(c_bra, c_ket, s) {
	                        var adjustment = s.length - (c_ket - c_bra),
	                            left = current.substring(0, c_bra),
	                            right = current.substring(c_ket);
	                        current = left + s + right;
	                        this.limit += adjustment;
	                        if (this.cursor >= c_ket) this.cursor += adjustment;else if (this.cursor > c_bra) this.cursor = c_bra;
	                        return adjustment;
	                    },
	                    slice_check: function slice_check() {
	                        if (this.bra < 0 || this.bra > this.ket || this.ket > this.limit || this.limit > current.length) throw "faulty slice operation";
	                    },
	                    slice_from: function slice_from(s) {
	                        this.slice_check();
	                        this.replace_s(this.bra, this.ket, s);
	                    },
	                    slice_del: function slice_del() {
	                        this.slice_from("");
	                    },
	                    insert: function insert(c_bra, c_ket, s) {
	                        var adjustment = this.replace_s(c_bra, c_ket, s);
	                        if (c_bra <= this.bra) this.bra += adjustment;
	                        if (c_bra <= this.ket) this.ket += adjustment;
	                    },
	                    slice_to: function slice_to() {
	                        this.slice_check();
	                        return current.substring(this.bra, this.ket);
	                    },
	                    eq_v_b: function eq_v_b(s) {
	                        return this.eq_s_b(s.length, s);
	                    }
	                };
	            }
	        };
	
	        lunr.trimmerSupport = {
	            generateTrimmer: function generateTrimmer(wordCharacters) {
	                var startRegex = new RegExp("^[^" + wordCharacters + "]+");
	                var endRegex = new RegExp("[^" + wordCharacters + "]+$");
	
	                return function (token) {
	                    // for lunr version 2
	                    if (typeof token.update === "function") {
	                        return token.update(function (s) {
	                            return s.replace(startRegex, '').replace(endRegex, '');
	                        });
	                    } else {
	                        // for lunr version 1
	                        return token.replace(startRegex, '').replace(endRegex, '');
	                    }
	                };
	            }
	        };
	    };
	});

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/**
	 * export the module via AMD, CommonJS or as a browser global
	 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
	 */
	;(function (root, factory) {
	    if (true) {
	        // AMD. Register as an anonymous module.
	        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if ((typeof exports === 'undefined' ? 'undefined' : _typeof(exports)) === 'object') {
	        /**
	         * Node. Does not work with strict CommonJS, but
	         * only CommonJS-like environments that support module.exports,
	         * like Node.
	         */
	        module.exports = factory();
	    } else {
	        // Browser globals (root is window)
	        factory()(root.lunr);
	    }
	})(undefined, function () {
	    /**
	     * Just return a value to define the module export.
	     * This example returns an object, but the module
	     * can return a function as the exported value.
	     */
	    return function (lunr) {
	        /* Set up the pipeline for indexing content in multiple languages. The
	           corresponding lunr.{lang} files must be loaded before calling this
	           function; English ('en') is built in.
	            Returns: a lunr plugin for use in your indexer.
	            Known drawback: every word will be stemmed with stemmers for every
	           language. This could mean that sometimes words that have the same
	           stemming root will not be stemmed as such.
	           */
	        lunr.multiLanguage = function () /* lang1, lang2, ... */{
	            var languages = Array.prototype.slice.call(arguments);
	            var nameSuffix = languages.join('-');
	            var wordCharacters = "";
	            var pipeline = [];
	            var searchPipeline = [];
	            for (var i = 0; i < languages.length; ++i) {
	                if (languages[i] == 'en') {
	                    wordCharacters += '\\w';
	                    pipeline.unshift(lunr.stopWordFilter);
	                    pipeline.push(lunr.stemmer);
	                    searchPipeline.push(lunr.stemmer);
	                } else {
	                    wordCharacters += lunr[languages[i]].wordCharacters;
	                    pipeline.unshift(lunr[languages[i]].stopWordFilter);
	                    pipeline.push(lunr[languages[i]].stemmer);
	                    searchPipeline.push(lunr[languages[i]].stemmer);
	                }
	            };
	            var multiTrimmer = lunr.trimmerSupport.generateTrimmer(wordCharacters);
	            lunr.Pipeline.registerFunction(multiTrimmer, 'lunr-multi-trimmer-' + nameSuffix);
	            pipeline.unshift(multiTrimmer);
	
	            return function () {
	                this.pipeline.reset();
	
	                this.pipeline.add.apply(this.pipeline, pipeline);
	
	                // for lunr version 2
	                // this is necessary so that every searched word is also stemmed before
	                // in lunr <= 1 this is not needed, as it is done using the normal pipeline
	                if (this.searchPipeline) {
	                    this.searchPipeline.reset();
	                    this.searchPipeline.add.apply(this.searchPipeline, searchPipeline);
	                }
	            };
	        };
	    };
	});

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/*!
	 * Lunr languages, `Russian` language
	 * https://github.com/MihaiValentin/lunr-languages
	 *
	 * Copyright 2014, Mihai Valentin
	 * http://www.mozilla.org/MPL/
	 */
	/*!
	 * based on
	 * Snowball JavaScript Library v0.3
	 * http://code.google.com/p/urim/
	 * http://snowball.tartarus.org/
	 *
	 * Copyright 2010, Oleg Mazko
	 * http://www.mozilla.org/MPL/
	 */
	
	/**
	 * export the module via AMD, CommonJS or as a browser global
	 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
	 */
	;
	(function (root, factory) {
	  if (true) {
	    // AMD. Register as an anonymous module.
	    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ((typeof exports === 'undefined' ? 'undefined' : _typeof(exports)) === 'object') {
	    /**
	     * Node. Does not work with strict CommonJS, but
	     * only CommonJS-like environments that support module.exports,
	     * like Node.
	     */
	    module.exports = factory();
	  } else {
	    // Browser globals (root is window)
	    factory()(root.lunr);
	  }
	})(undefined, function () {
	  /**
	   * Just return a value to define the module export.
	   * This example returns an object, but the module
	   * can return a function as the exported value.
	   */
	  return function (lunr) {
	    /* throw error if lunr is not yet included */
	    if ('undefined' === typeof lunr) {
	      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
	    }
	
	    /* throw error if lunr stemmer support is not yet included */
	    if ('undefined' === typeof lunr.stemmerSupport) {
	      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
	    }
	
	    /* register specific locale function */
	    lunr.ru = function () {
	      this.pipeline.reset();
	      this.pipeline.add(lunr.ru.trimmer, lunr.ru.stopWordFilter, lunr.ru.stemmer);
	
	      // for lunr version 2
	      // this is necessary so that every searched word is also stemmed before
	      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
	      if (this.searchPipeline) {
	        this.searchPipeline.reset();
	        this.searchPipeline.add(lunr.ru.stemmer);
	      }
	    };
	
	    /* lunr trimmer function */
	    lunr.ru.wordCharacters = '\u0400-\u0484\u0487-\u052F\u1D2B\u1D78\u2DE0-\u2DFF\uA640-\uA69F\uFE2E\uFE2F';
	    lunr.ru.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.ru.wordCharacters);
	
	    lunr.Pipeline.registerFunction(lunr.ru.trimmer, 'trimmer-ru');
	
	    /* lunr stemmer function */
	    lunr.ru.stemmer = function () {
	      /* create the wrapped stemmer object */
	      var Among = lunr.stemmerSupport.Among,
	          SnowballProgram = lunr.stemmerSupport.SnowballProgram,
	          st = new function RussianStemmer() {
	        var a_0 = [new Among('\u0432', -1, 1), new Among('\u0438\u0432', 0, 2), new Among('\u044B\u0432', 0, 2), new Among('\u0432\u0448\u0438', -1, 1), new Among('\u0438\u0432\u0448\u0438', 3, 2), new Among('\u044B\u0432\u0448\u0438', 3, 2), new Among('\u0432\u0448\u0438\u0441\u044C', -1, 1), new Among('\u0438\u0432\u0448\u0438\u0441\u044C', 6, 2), new Among('\u044B\u0432\u0448\u0438\u0441\u044C', 6, 2)],
	            a_1 = [new Among('\u0435\u0435', -1, 1), new Among('\u0438\u0435', -1, 1), new Among('\u043E\u0435', -1, 1), new Among('\u044B\u0435', -1, 1), new Among('\u0438\u043C\u0438', -1, 1), new Among('\u044B\u043C\u0438', -1, 1), new Among('\u0435\u0439', -1, 1), new Among('\u0438\u0439', -1, 1), new Among('\u043E\u0439', -1, 1), new Among('\u044B\u0439', -1, 1), new Among('\u0435\u043C', -1, 1), new Among('\u0438\u043C', -1, 1), new Among('\u043E\u043C', -1, 1), new Among('\u044B\u043C', -1, 1), new Among('\u0435\u0433\u043E', -1, 1), new Among('\u043E\u0433\u043E', -1, 1), new Among('\u0435\u043C\u0443', -1, 1), new Among('\u043E\u043C\u0443', -1, 1), new Among('\u0438\u0445', -1, 1), new Among('\u044B\u0445', -1, 1), new Among('\u0435\u044E', -1, 1), new Among('\u043E\u044E', -1, 1), new Among('\u0443\u044E', -1, 1), new Among('\u044E\u044E', -1, 1), new Among('\u0430\u044F', -1, 1), new Among('\u044F\u044F', -1, 1)],
	            a_2 = [new Among('\u0435\u043C', -1, 1), new Among('\u043D\u043D', -1, 1), new Among('\u0432\u0448', -1, 1), new Among('\u0438\u0432\u0448', 2, 2), new Among('\u044B\u0432\u0448', 2, 2), new Among('\u0449', -1, 1), new Among('\u044E\u0449', 5, 1), new Among('\u0443\u044E\u0449', 6, 2)],
	            a_3 = [new Among('\u0441\u044C', -1, 1), new Among('\u0441\u044F', -1, 1)],
	            a_4 = [new Among('\u043B\u0430', -1, 1), new Among('\u0438\u043B\u0430', 0, 2), new Among('\u044B\u043B\u0430', 0, 2), new Among('\u043D\u0430', -1, 1), new Among('\u0435\u043D\u0430', 3, 2), new Among('\u0435\u0442\u0435', -1, 1), new Among('\u0438\u0442\u0435', -1, 2), new Among('\u0439\u0442\u0435', -1, 1), new Among('\u0435\u0439\u0442\u0435', 7, 2), new Among('\u0443\u0439\u0442\u0435', 7, 2), new Among('\u043B\u0438', -1, 1), new Among('\u0438\u043B\u0438', 10, 2), new Among('\u044B\u043B\u0438', 10, 2), new Among('\u0439', -1, 1), new Among('\u0435\u0439', 13, 2), new Among('\u0443\u0439', 13, 2), new Among('\u043B', -1, 1), new Among('\u0438\u043B', 16, 2), new Among('\u044B\u043B', 16, 2), new Among('\u0435\u043C', -1, 1), new Among('\u0438\u043C', -1, 2), new Among('\u044B\u043C', -1, 2), new Among('\u043D', -1, 1), new Among('\u0435\u043D', 22, 2), new Among('\u043B\u043E', -1, 1), new Among('\u0438\u043B\u043E', 24, 2), new Among('\u044B\u043B\u043E', 24, 2), new Among('\u043D\u043E', -1, 1), new Among('\u0435\u043D\u043E', 27, 2), new Among('\u043D\u043D\u043E', 27, 1), new Among('\u0435\u0442', -1, 1), new Among('\u0443\u0435\u0442', 30, 2), new Among('\u0438\u0442', -1, 2), new Among('\u044B\u0442', -1, 2), new Among('\u044E\u0442', -1, 1), new Among('\u0443\u044E\u0442', 34, 2), new Among('\u044F\u0442', -1, 2), new Among('\u043D\u044B', -1, 1), new Among('\u0435\u043D\u044B', 37, 2), new Among('\u0442\u044C', -1, 1), new Among('\u0438\u0442\u044C', 39, 2), new Among('\u044B\u0442\u044C', 39, 2), new Among('\u0435\u0448\u044C', -1, 1), new Among('\u0438\u0448\u044C', -1, 2), new Among('\u044E', -1, 2), new Among('\u0443\u044E', 44, 2)],
	            a_5 = [new Among('\u0430', -1, 1), new Among('\u0435\u0432', -1, 1), new Among('\u043E\u0432', -1, 1), new Among('\u0435', -1, 1), new Among('\u0438\u0435', 3, 1), new Among('\u044C\u0435', 3, 1), new Among('\u0438', -1, 1), new Among('\u0435\u0438', 6, 1), new Among('\u0438\u0438', 6, 1), new Among('\u0430\u043C\u0438', 6, 1), new Among('\u044F\u043C\u0438', 6, 1), new Among('\u0438\u044F\u043C\u0438', 10, 1), new Among('\u0439', -1, 1), new Among('\u0435\u0439', 12, 1), new Among('\u0438\u0435\u0439', 13, 1), new Among('\u0438\u0439', 12, 1), new Among('\u043E\u0439', 12, 1), new Among('\u0430\u043C', -1, 1), new Among('\u0435\u043C', -1, 1), new Among('\u0438\u0435\u043C', 18, 1), new Among('\u043E\u043C', -1, 1), new Among('\u044F\u043C', -1, 1), new Among('\u0438\u044F\u043C', 21, 1), new Among('\u043E', -1, 1), new Among('\u0443', -1, 1), new Among('\u0430\u0445', -1, 1), new Among('\u044F\u0445', -1, 1), new Among('\u0438\u044F\u0445', 26, 1), new Among('\u044B', -1, 1), new Among('\u044C', -1, 1), new Among('\u044E', -1, 1), new Among('\u0438\u044E', 30, 1), new Among('\u044C\u044E', 30, 1), new Among('\u044F', -1, 1), new Among('\u0438\u044F', 33, 1), new Among('\u044C\u044F', 33, 1)],
	            a_6 = [new Among('\u043E\u0441\u0442', -1, 1), new Among('\u043E\u0441\u0442\u044C', -1, 1)],
	            a_7 = [new Among('\u0435\u0439\u0448\u0435', -1, 1), new Among('\u043D', -1, 2), new Among('\u0435\u0439\u0448', -1, 1), new Among('\u044C', -1, 3)],
	            g_v = [33, 65, 8, 232],
	            I_p2,
	            I_pV,
	            sbp = new SnowballProgram();
	        this.setCurrent = function (word) {
	          sbp.setCurrent(word);
	        };
	        this.getCurrent = function () {
	          return sbp.getCurrent();
	        };
	
	        function habr3() {
	          while (!sbp.in_grouping(g_v, 1072, 1103)) {
	            if (sbp.cursor >= sbp.limit) return false;
	            sbp.cursor++;
	          }
	          return true;
	        }
	
	        function habr4() {
	          while (!sbp.out_grouping(g_v, 1072, 1103)) {
	            if (sbp.cursor >= sbp.limit) return false;
	            sbp.cursor++;
	          }
	          return true;
	        }
	
	        function r_mark_regions() {
	          I_pV = sbp.limit;
	          I_p2 = I_pV;
	          if (habr3()) {
	            I_pV = sbp.cursor;
	            if (habr4()) if (habr3()) if (habr4()) I_p2 = sbp.cursor;
	          }
	        }
	
	        function r_R2() {
	          return I_p2 <= sbp.cursor;
	        }
	
	        function habr2(a, n) {
	          var among_var, v_1;
	          sbp.ket = sbp.cursor;
	          among_var = sbp.find_among_b(a, n);
	          if (among_var) {
	            sbp.bra = sbp.cursor;
	            switch (among_var) {
	              case 1:
	                v_1 = sbp.limit - sbp.cursor;
	                if (!sbp.eq_s_b(1, '\u0430')) {
	                  sbp.cursor = sbp.limit - v_1;
	                  if (!sbp.eq_s_b(1, '\u044F')) return false;
	                }
	              case 2:
	                sbp.slice_del();
	                break;
	            }
	            return true;
	          }
	          return false;
	        }
	
	        function r_perfective_gerund() {
	          return habr2(a_0, 9);
	        }
	
	        function habr1(a, n) {
	          var among_var;
	          sbp.ket = sbp.cursor;
	          among_var = sbp.find_among_b(a, n);
	          if (among_var) {
	            sbp.bra = sbp.cursor;
	            if (among_var == 1) sbp.slice_del();
	            return true;
	          }
	          return false;
	        }
	
	        function r_adjective() {
	          return habr1(a_1, 26);
	        }
	
	        function r_adjectival() {
	          var among_var;
	          if (r_adjective()) {
	            habr2(a_2, 8);
	            return true;
	          }
	          return false;
	        }
	
	        function r_reflexive() {
	          return habr1(a_3, 2);
	        }
	
	        function r_verb() {
	          return habr2(a_4, 46);
	        }
	
	        function r_noun() {
	          habr1(a_5, 36);
	        }
	
	        function r_derivational() {
	          var among_var;
	          sbp.ket = sbp.cursor;
	          among_var = sbp.find_among_b(a_6, 2);
	          if (among_var) {
	            sbp.bra = sbp.cursor;
	            if (r_R2() && among_var == 1) sbp.slice_del();
	          }
	        }
	
	        function r_tidy_up() {
	          var among_var;
	          sbp.ket = sbp.cursor;
	          among_var = sbp.find_among_b(a_7, 4);
	          if (among_var) {
	            sbp.bra = sbp.cursor;
	            switch (among_var) {
	              case 1:
	                sbp.slice_del();
	                sbp.ket = sbp.cursor;
	                if (!sbp.eq_s_b(1, '\u043D')) break;
	                sbp.bra = sbp.cursor;
	              case 2:
	                if (!sbp.eq_s_b(1, '\u043D')) break;
	              case 3:
	                sbp.slice_del();
	                break;
	            }
	          }
	        }
	        this.stem = function () {
	          r_mark_regions();
	          sbp.cursor = sbp.limit;
	          if (sbp.cursor < I_pV) return false;
	          sbp.limit_backward = I_pV;
	          if (!r_perfective_gerund()) {
	            sbp.cursor = sbp.limit;
	            if (!r_reflexive()) sbp.cursor = sbp.limit;
	            if (!r_adjectival()) {
	              sbp.cursor = sbp.limit;
	              if (!r_verb()) {
	                sbp.cursor = sbp.limit;
	                r_noun();
	              }
	            }
	          }
	          sbp.cursor = sbp.limit;
	          sbp.ket = sbp.cursor;
	          if (sbp.eq_s_b(1, '\u0438')) {
	            sbp.bra = sbp.cursor;
	            sbp.slice_del();
	          } else sbp.cursor = sbp.limit;
	          r_derivational();
	          sbp.cursor = sbp.limit;
	          r_tidy_up();
	          return true;
	        };
	      }();
	
	      /* and return a function that stems a word for the current locale */
	      return function (token) {
	        // for lunr version 2
	        if (typeof token.update === "function") {
	          return token.update(function (word) {
	            st.setCurrent(word);
	            st.stem();
	            return st.getCurrent();
	          });
	        } else {
	          // for lunr version <= 1
	          st.setCurrent(token);
	          st.stem();
	          return st.getCurrent();
	        }
	      };
	    }();
	
	    lunr.Pipeline.registerFunction(lunr.ru.stemmer, 'stemmer-ru');
	
	    lunr.ru.stopWordFilter = lunr.generateStopWordFilter('алло без близко более больше будем будет будете будешь будто буду будут будь бы бывает бывь был была были было быть в важная важное важные важный вам вами вас ваш ваша ваше ваши вверх вдали вдруг ведь везде весь вниз внизу во вокруг вон восемнадцатый восемнадцать восемь восьмой вот впрочем времени время все всегда всего всем всеми всему всех всею всю всюду вся всё второй вы г где говорил говорит год года году да давно даже далеко дальше даром два двадцатый двадцать две двенадцатый двенадцать двух девятнадцатый девятнадцать девятый девять действительно дел день десятый десять для до довольно долго должно другая другие других друго другое другой е его ее ей ему если есть еще ещё ею её ж же жизнь за занят занята занято заняты затем зато зачем здесь значит и из или им именно иметь ими имя иногда их к каждая каждое каждые каждый кажется как какая какой кем когда кого ком кому конечно которая которого которой которые который которых кроме кругом кто куда лет ли лишь лучше люди м мало между меля менее меньше меня миллионов мимо мира мне много многочисленная многочисленное многочисленные многочисленный мной мною мог могут мож может можно можхо мои мой мор мочь моя моё мы на наверху над надо назад наиболее наконец нам нами нас начала наш наша наше наши не него недавно недалеко нее ней нельзя нем немного нему непрерывно нередко несколько нет нею неё ни нибудь ниже низко никогда никуда ними них ничего но ну нужно нх о об оба обычно один одиннадцатый одиннадцать однажды однако одного одной около он она они оно опять особенно от отовсюду отсюда очень первый перед по под пожалуйста позже пока пор пора после посреди потом потому почему почти прекрасно при про просто против процентов пятнадцатый пятнадцать пятый пять раз разве рано раньше рядом с сам сама сами самим самими самих само самого самой самом самому саму свое своего своей свои своих свою сеаой себе себя сегодня седьмой сейчас семнадцатый семнадцать семь сих сказал сказала сказать сколько слишком сначала снова со собой собою совсем спасибо стал суть т та так такая также такие такое такой там твой твоя твоё те тебе тебя тем теми теперь тех то тобой тобою тогда того тоже только том тому тот тою третий три тринадцатый тринадцать ту туда тут ты тысяч у уж уже уметь хорошо хотеть хоть хотя хочешь часто чаще чего человек чем чему через четвертый четыре четырнадцатый четырнадцать что чтоб чтобы чуть шестнадцатый шестнадцать шестой шесть эта эти этим этими этих это этого этой этом этому этот эту я ﻿а'.split(' '));
	
	    lunr.Pipeline.registerFunction(lunr.ru.stopWordFilter, 'stopWordFilter-ru');
	  };
	});

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/*!
	 * Lunr languages, `Portuguese` language
	 * https://github.com/MihaiValentin/lunr-languages
	 *
	 * Copyright 2014, Mihai Valentin
	 * http://www.mozilla.org/MPL/
	 */
	/*!
	 * based on
	 * Snowball JavaScript Library v0.3
	 * http://code.google.com/p/urim/
	 * http://snowball.tartarus.org/
	 *
	 * Copyright 2010, Oleg Mazko
	 * http://www.mozilla.org/MPL/
	 */
	
	/**
	 * export the module via AMD, CommonJS or as a browser global
	 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
	 */
	;
	(function (root, factory) {
	  if (true) {
	    // AMD. Register as an anonymous module.
	    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ((typeof exports === 'undefined' ? 'undefined' : _typeof(exports)) === 'object') {
	    /**
	     * Node. Does not work with strict CommonJS, but
	     * only CommonJS-like environments that support module.exports,
	     * like Node.
	     */
	    module.exports = factory();
	  } else {
	    // Browser globals (root is window)
	    factory()(root.lunr);
	  }
	})(undefined, function () {
	  /**
	   * Just return a value to define the module export.
	   * This example returns an object, but the module
	   * can return a function as the exported value.
	   */
	  return function (lunr) {
	    /* throw error if lunr is not yet included */
	    if ('undefined' === typeof lunr) {
	      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
	    }
	
	    /* throw error if lunr stemmer support is not yet included */
	    if ('undefined' === typeof lunr.stemmerSupport) {
	      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
	    }
	
	    /* register specific locale function */
	    lunr.pt = function () {
	      this.pipeline.reset();
	      this.pipeline.add(lunr.pt.trimmer, lunr.pt.stopWordFilter, lunr.pt.stemmer);
	
	      // for lunr version 2
	      // this is necessary so that every searched word is also stemmed before
	      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
	      if (this.searchPipeline) {
	        this.searchPipeline.reset();
	        this.searchPipeline.add(lunr.pt.stemmer);
	      }
	    };
	
	    /* lunr trimmer function */
	    lunr.pt.wordCharacters = 'A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A';
	    lunr.pt.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.pt.wordCharacters);
	
	    lunr.Pipeline.registerFunction(lunr.pt.trimmer, 'trimmer-pt');
	
	    /* lunr stemmer function */
	    lunr.pt.stemmer = function () {
	      /* create the wrapped stemmer object */
	      var Among = lunr.stemmerSupport.Among,
	          SnowballProgram = lunr.stemmerSupport.SnowballProgram,
	          st = new function PortugueseStemmer() {
	        var a_0 = [new Among("", -1, 3), new Among('\xE3', 0, 1), new Among('\xF5', 0, 2)],
	            a_1 = [new Among("", -1, 3), new Among("a~", 0, 1), new Among("o~", 0, 2)],
	            a_2 = [new Among("ic", -1, -1), new Among("ad", -1, -1), new Among("os", -1, -1), new Among("iv", -1, 1)],
	            a_3 = [new Among("ante", -1, 1), new Among("avel", -1, 1), new Among('\xEDvel', -1, 1)],
	            a_4 = [new Among("ic", -1, 1), new Among("abil", -1, 1), new Among("iv", -1, 1)],
	            a_5 = [new Among("ica", -1, 1), new Among('\xE2ncia', -1, 1), new Among('\xEAncia', -1, 4), new Among("ira", -1, 9), new Among("adora", -1, 1), new Among("osa", -1, 1), new Among("ista", -1, 1), new Among("iva", -1, 8), new Among("eza", -1, 1), new Among('log\xEDa', -1, 2), new Among("idade", -1, 7), new Among("ante", -1, 1), new Among("mente", -1, 6), new Among("amente", 12, 5), new Among('\xE1vel', -1, 1), new Among('\xEDvel', -1, 1), new Among('uci\xF3n', -1, 3), new Among("ico", -1, 1), new Among("ismo", -1, 1), new Among("oso", -1, 1), new Among("amento", -1, 1), new Among("imento", -1, 1), new Among("ivo", -1, 8), new Among('a\xE7a~o', -1, 1), new Among("ador", -1, 1), new Among("icas", -1, 1), new Among('\xEAncias', -1, 4), new Among("iras", -1, 9), new Among("adoras", -1, 1), new Among("osas", -1, 1), new Among("istas", -1, 1), new Among("ivas", -1, 8), new Among("ezas", -1, 1), new Among('log\xEDas', -1, 2), new Among("idades", -1, 7), new Among("uciones", -1, 3), new Among("adores", -1, 1), new Among("antes", -1, 1), new Among('a\xE7o~es', -1, 1), new Among("icos", -1, 1), new Among("ismos", -1, 1), new Among("osos", -1, 1), new Among("amentos", -1, 1), new Among("imentos", -1, 1), new Among("ivos", -1, 8)],
	            a_6 = [new Among("ada", -1, 1), new Among("ida", -1, 1), new Among("ia", -1, 1), new Among("aria", 2, 1), new Among("eria", 2, 1), new Among("iria", 2, 1), new Among("ara", -1, 1), new Among("era", -1, 1), new Among("ira", -1, 1), new Among("ava", -1, 1), new Among("asse", -1, 1), new Among("esse", -1, 1), new Among("isse", -1, 1), new Among("aste", -1, 1), new Among("este", -1, 1), new Among("iste", -1, 1), new Among("ei", -1, 1), new Among("arei", 16, 1), new Among("erei", 16, 1), new Among("irei", 16, 1), new Among("am", -1, 1), new Among("iam", 20, 1), new Among("ariam", 21, 1), new Among("eriam", 21, 1), new Among("iriam", 21, 1), new Among("aram", 20, 1), new Among("eram", 20, 1), new Among("iram", 20, 1), new Among("avam", 20, 1), new Among("em", -1, 1), new Among("arem", 29, 1), new Among("erem", 29, 1), new Among("irem", 29, 1), new Among("assem", 29, 1), new Among("essem", 29, 1), new Among("issem", 29, 1), new Among("ado", -1, 1), new Among("ido", -1, 1), new Among("ando", -1, 1), new Among("endo", -1, 1), new Among("indo", -1, 1), new Among("ara~o", -1, 1), new Among("era~o", -1, 1), new Among("ira~o", -1, 1), new Among("ar", -1, 1), new Among("er", -1, 1), new Among("ir", -1, 1), new Among("as", -1, 1), new Among("adas", 47, 1), new Among("idas", 47, 1), new Among("ias", 47, 1), new Among("arias", 50, 1), new Among("erias", 50, 1), new Among("irias", 50, 1), new Among("aras", 47, 1), new Among("eras", 47, 1), new Among("iras", 47, 1), new Among("avas", 47, 1), new Among("es", -1, 1), new Among("ardes", 58, 1), new Among("erdes", 58, 1), new Among("irdes", 58, 1), new Among("ares", 58, 1), new Among("eres", 58, 1), new Among("ires", 58, 1), new Among("asses", 58, 1), new Among("esses", 58, 1), new Among("isses", 58, 1), new Among("astes", 58, 1), new Among("estes", 58, 1), new Among("istes", 58, 1), new Among("is", -1, 1), new Among("ais", 71, 1), new Among("eis", 71, 1), new Among("areis", 73, 1), new Among("ereis", 73, 1), new Among("ireis", 73, 1), new Among('\xE1reis', 73, 1), new Among('\xE9reis', 73, 1), new Among('\xEDreis', 73, 1), new Among('\xE1sseis', 73, 1), new Among('\xE9sseis', 73, 1), new Among('\xEDsseis', 73, 1), new Among('\xE1veis', 73, 1), new Among('\xEDeis', 73, 1), new Among('ar\xEDeis', 84, 1), new Among('er\xEDeis', 84, 1), new Among('ir\xEDeis', 84, 1), new Among("ados", -1, 1), new Among("idos", -1, 1), new Among("amos", -1, 1), new Among('\xE1ramos', 90, 1), new Among('\xE9ramos', 90, 1), new Among('\xEDramos', 90, 1), new Among('\xE1vamos', 90, 1), new Among('\xEDamos', 90, 1), new Among('ar\xEDamos', 95, 1), new Among('er\xEDamos', 95, 1), new Among('ir\xEDamos', 95, 1), new Among("emos", -1, 1), new Among("aremos", 99, 1), new Among("eremos", 99, 1), new Among("iremos", 99, 1), new Among('\xE1ssemos', 99, 1), new Among('\xEAssemos', 99, 1), new Among('\xEDssemos', 99, 1), new Among("imos", -1, 1), new Among("armos", -1, 1), new Among("ermos", -1, 1), new Among("irmos", -1, 1), new Among('\xE1mos', -1, 1), new Among('ar\xE1s', -1, 1), new Among('er\xE1s', -1, 1), new Among('ir\xE1s', -1, 1), new Among("eu", -1, 1), new Among("iu", -1, 1), new Among("ou", -1, 1), new Among('ar\xE1', -1, 1), new Among('er\xE1', -1, 1), new Among('ir\xE1', -1, 1)],
	            a_7 = [new Among("a", -1, 1), new Among("i", -1, 1), new Among("o", -1, 1), new Among("os", -1, 1), new Among('\xE1', -1, 1), new Among('\xED', -1, 1), new Among('\xF3', -1, 1)],
	            a_8 = [new Among("e", -1, 1), new Among('\xE7', -1, 2), new Among('\xE9', -1, 1), new Among('\xEA', -1, 1)],
	            g_v = [17, 65, 16, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 3, 19, 12, 2],
	            I_p2,
	            I_p1,
	            I_pV,
	            sbp = new SnowballProgram();
	        this.setCurrent = function (word) {
	          sbp.setCurrent(word);
	        };
	        this.getCurrent = function () {
	          return sbp.getCurrent();
	        };
	
	        function r_prelude() {
	          var among_var;
	          while (true) {
	            sbp.bra = sbp.cursor;
	            among_var = sbp.find_among(a_0, 3);
	            if (among_var) {
	              sbp.ket = sbp.cursor;
	              switch (among_var) {
	                case 1:
	                  sbp.slice_from("a~");
	                  continue;
	                case 2:
	                  sbp.slice_from("o~");
	                  continue;
	                case 3:
	                  if (sbp.cursor >= sbp.limit) break;
	                  sbp.cursor++;
	                  continue;
	              }
	            }
	            break;
	          }
	        }
	
	        function habr2() {
	          if (sbp.out_grouping(g_v, 97, 250)) {
	            while (!sbp.in_grouping(g_v, 97, 250)) {
	              if (sbp.cursor >= sbp.limit) return true;
	              sbp.cursor++;
	            }
	            return false;
	          }
	          return true;
	        }
	
	        function habr3() {
	          if (sbp.in_grouping(g_v, 97, 250)) {
	            while (!sbp.out_grouping(g_v, 97, 250)) {
	              if (sbp.cursor >= sbp.limit) return false;
	              sbp.cursor++;
	            }
	          }
	          I_pV = sbp.cursor;
	          return true;
	        }
	
	        function habr4() {
	          var v_1 = sbp.cursor,
	              v_2,
	              v_3;
	          if (sbp.in_grouping(g_v, 97, 250)) {
	            v_2 = sbp.cursor;
	            if (habr2()) {
	              sbp.cursor = v_2;
	              if (habr3()) return;
	            } else I_pV = sbp.cursor;
	          }
	          sbp.cursor = v_1;
	          if (sbp.out_grouping(g_v, 97, 250)) {
	            v_3 = sbp.cursor;
	            if (habr2()) {
	              sbp.cursor = v_3;
	              if (!sbp.in_grouping(g_v, 97, 250) || sbp.cursor >= sbp.limit) return;
	              sbp.cursor++;
	            }
	            I_pV = sbp.cursor;
	          }
	        }
	
	        function habr5() {
	          while (!sbp.in_grouping(g_v, 97, 250)) {
	            if (sbp.cursor >= sbp.limit) return false;
	            sbp.cursor++;
	          }
	          while (!sbp.out_grouping(g_v, 97, 250)) {
	            if (sbp.cursor >= sbp.limit) return false;
	            sbp.cursor++;
	          }
	          return true;
	        }
	
	        function r_mark_regions() {
	          var v_1 = sbp.cursor;
	          I_pV = sbp.limit;
	          I_p1 = I_pV;
	          I_p2 = I_pV;
	          habr4();
	          sbp.cursor = v_1;
	          if (habr5()) {
	            I_p1 = sbp.cursor;
	            if (habr5()) I_p2 = sbp.cursor;
	          }
	        }
	
	        function r_postlude() {
	          var among_var;
	          while (true) {
	            sbp.bra = sbp.cursor;
	            among_var = sbp.find_among(a_1, 3);
	            if (among_var) {
	              sbp.ket = sbp.cursor;
	              switch (among_var) {
	                case 1:
	                  sbp.slice_from('\xE3');
	                  continue;
	                case 2:
	                  sbp.slice_from('\xF5');
	                  continue;
	                case 3:
	                  if (sbp.cursor >= sbp.limit) break;
	                  sbp.cursor++;
	                  continue;
	              }
	            }
	            break;
	          }
	        }
	
	        function r_RV() {
	          return I_pV <= sbp.cursor;
	        }
	
	        function r_R1() {
	          return I_p1 <= sbp.cursor;
	        }
	
	        function r_R2() {
	          return I_p2 <= sbp.cursor;
	        }
	
	        function r_standard_suffix() {
	          var among_var;
	          sbp.ket = sbp.cursor;
	          among_var = sbp.find_among_b(a_5, 45);
	          if (!among_var) return false;
	          sbp.bra = sbp.cursor;
	          switch (among_var) {
	            case 1:
	              if (!r_R2()) return false;
	              sbp.slice_del();
	              break;
	            case 2:
	              if (!r_R2()) return false;
	              sbp.slice_from("log");
	              break;
	            case 3:
	              if (!r_R2()) return false;
	              sbp.slice_from("u");
	              break;
	            case 4:
	              if (!r_R2()) return false;
	              sbp.slice_from("ente");
	              break;
	            case 5:
	              if (!r_R1()) return false;
	              sbp.slice_del();
	              sbp.ket = sbp.cursor;
	              among_var = sbp.find_among_b(a_2, 4);
	              if (among_var) {
	                sbp.bra = sbp.cursor;
	                if (r_R2()) {
	                  sbp.slice_del();
	                  if (among_var == 1) {
	                    sbp.ket = sbp.cursor;
	                    if (sbp.eq_s_b(2, "at")) {
	                      sbp.bra = sbp.cursor;
	                      if (r_R2()) sbp.slice_del();
	                    }
	                  }
	                }
	              }
	              break;
	            case 6:
	              if (!r_R2()) return false;
	              sbp.slice_del();
	              sbp.ket = sbp.cursor;
	              among_var = sbp.find_among_b(a_3, 3);
	              if (among_var) {
	                sbp.bra = sbp.cursor;
	                if (among_var == 1) if (r_R2()) sbp.slice_del();
	              }
	              break;
	            case 7:
	              if (!r_R2()) return false;
	              sbp.slice_del();
	              sbp.ket = sbp.cursor;
	              among_var = sbp.find_among_b(a_4, 3);
	              if (among_var) {
	                sbp.bra = sbp.cursor;
	                if (among_var == 1) if (r_R2()) sbp.slice_del();
	              }
	              break;
	            case 8:
	              if (!r_R2()) return false;
	              sbp.slice_del();
	              sbp.ket = sbp.cursor;
	              if (sbp.eq_s_b(2, "at")) {
	                sbp.bra = sbp.cursor;
	                if (r_R2()) sbp.slice_del();
	              }
	              break;
	            case 9:
	              if (!r_RV() || !sbp.eq_s_b(1, "e")) return false;
	              sbp.slice_from("ir");
	              break;
	          }
	          return true;
	        }
	
	        function r_verb_suffix() {
	          var among_var, v_1;
	          if (sbp.cursor >= I_pV) {
	            v_1 = sbp.limit_backward;
	            sbp.limit_backward = I_pV;
	            sbp.ket = sbp.cursor;
	            among_var = sbp.find_among_b(a_6, 120);
	            if (among_var) {
	              sbp.bra = sbp.cursor;
	              if (among_var == 1) sbp.slice_del();
	              sbp.limit_backward = v_1;
	              return true;
	            }
	            sbp.limit_backward = v_1;
	          }
	          return false;
	        }
	
	        function r_residual_suffix() {
	          var among_var;
	          sbp.ket = sbp.cursor;
	          among_var = sbp.find_among_b(a_7, 7);
	          if (among_var) {
	            sbp.bra = sbp.cursor;
	            if (among_var == 1) if (r_RV()) sbp.slice_del();
	          }
	        }
	
	        function habr6(c1, c2) {
	          if (sbp.eq_s_b(1, c1)) {
	            sbp.bra = sbp.cursor;
	            var v_1 = sbp.limit - sbp.cursor;
	            if (sbp.eq_s_b(1, c2)) {
	              sbp.cursor = sbp.limit - v_1;
	              if (r_RV()) sbp.slice_del();
	              return false;
	            }
	          }
	          return true;
	        }
	
	        function r_residual_form() {
	          var among_var, v_1, v_2, v_3;
	          sbp.ket = sbp.cursor;
	          among_var = sbp.find_among_b(a_8, 4);
	          if (among_var) {
	            sbp.bra = sbp.cursor;
	            switch (among_var) {
	              case 1:
	                if (r_RV()) {
	                  sbp.slice_del();
	                  sbp.ket = sbp.cursor;
	                  v_1 = sbp.limit - sbp.cursor;
	                  if (habr6("u", "g")) habr6("i", "c");
	                }
	                break;
	              case 2:
	                sbp.slice_from("c");
	                break;
	            }
	          }
	        }
	
	        function habr1() {
	          if (!r_standard_suffix()) {
	            sbp.cursor = sbp.limit;
	            if (!r_verb_suffix()) {
	              sbp.cursor = sbp.limit;
	              r_residual_suffix();
	              return;
	            }
	          }
	          sbp.cursor = sbp.limit;
	          sbp.ket = sbp.cursor;
	          if (sbp.eq_s_b(1, "i")) {
	            sbp.bra = sbp.cursor;
	            if (sbp.eq_s_b(1, "c")) {
	              sbp.cursor = sbp.limit;
	              if (r_RV()) sbp.slice_del();
	            }
	          }
	        }
	        this.stem = function () {
	          var v_1 = sbp.cursor;
	          r_prelude();
	          sbp.cursor = v_1;
	          r_mark_regions();
	          sbp.limit_backward = v_1;
	          sbp.cursor = sbp.limit;
	          habr1();
	          sbp.cursor = sbp.limit;
	          r_residual_form();
	          sbp.cursor = sbp.limit_backward;
	          r_postlude();
	          return true;
	        };
	      }();
	
	      /* and return a function that stems a word for the current locale */
	      return function (token) {
	        // for lunr version 2
	        if (typeof token.update === "function") {
	          return token.update(function (word) {
	            st.setCurrent(word);
	            st.stem();
	            return st.getCurrent();
	          });
	        } else {
	          // for lunr version <= 1
	          st.setCurrent(token);
	          st.stem();
	          return st.getCurrent();
	        }
	      };
	    }();
	
	    lunr.Pipeline.registerFunction(lunr.pt.stemmer, 'stemmer-pt');
	
	    lunr.pt.stopWordFilter = lunr.generateStopWordFilter('a ao aos aquela aquelas aquele aqueles aquilo as até com como da das de dela delas dele deles depois do dos e ela elas ele eles em entre era eram essa essas esse esses esta estamos estas estava estavam este esteja estejam estejamos estes esteve estive estivemos estiver estivera estiveram estiverem estivermos estivesse estivessem estivéramos estivéssemos estou está estávamos estão eu foi fomos for fora foram forem formos fosse fossem fui fôramos fôssemos haja hajam hajamos havemos hei houve houvemos houver houvera houveram houverei houverem houveremos houveria houveriam houvermos houverá houverão houveríamos houvesse houvessem houvéramos houvéssemos há hão isso isto já lhe lhes mais mas me mesmo meu meus minha minhas muito na nas nem no nos nossa nossas nosso nossos num numa não nós o os ou para pela pelas pelo pelos por qual quando que quem se seja sejam sejamos sem serei seremos seria seriam será serão seríamos seu seus somos sou sua suas são só também te tem temos tenha tenham tenhamos tenho terei teremos teria teriam terá terão teríamos teu teus teve tinha tinham tive tivemos tiver tivera tiveram tiverem tivermos tivesse tivessem tivéramos tivéssemos tu tua tuas tém tínhamos um uma você vocês vos à às éramos'.split(' '));
	
	    lunr.Pipeline.registerFunction(lunr.pt.stopWordFilter, 'stopWordFilter-pt');
	  };
	});

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/*!
	 * Lunr languages, `Italian` language
	 * https://github.com/MihaiValentin/lunr-languages
	 *
	 * Copyright 2014, Mihai Valentin
	 * http://www.mozilla.org/MPL/
	 */
	/*!
	 * based on
	 * Snowball JavaScript Library v0.3
	 * http://code.google.com/p/urim/
	 * http://snowball.tartarus.org/
	 *
	 * Copyright 2010, Oleg Mazko
	 * http://www.mozilla.org/MPL/
	 */
	
	/**
	 * export the module via AMD, CommonJS or as a browser global
	 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
	 */
	;
	(function (root, factory) {
	  if (true) {
	    // AMD. Register as an anonymous module.
	    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ((typeof exports === 'undefined' ? 'undefined' : _typeof(exports)) === 'object') {
	    /**
	     * Node. Does not work with strict CommonJS, but
	     * only CommonJS-like environments that support module.exports,
	     * like Node.
	     */
	    module.exports = factory();
	  } else {
	    // Browser globals (root is window)
	    factory()(root.lunr);
	  }
	})(undefined, function () {
	  /**
	   * Just return a value to define the module export.
	   * This example returns an object, but the module
	   * can return a function as the exported value.
	   */
	  return function (lunr) {
	    /* throw error if lunr is not yet included */
	    if ('undefined' === typeof lunr) {
	      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
	    }
	
	    /* throw error if lunr stemmer support is not yet included */
	    if ('undefined' === typeof lunr.stemmerSupport) {
	      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
	    }
	
	    /* register specific locale function */
	    lunr.it = function () {
	      this.pipeline.reset();
	      this.pipeline.add(lunr.it.trimmer, lunr.it.stopWordFilter, lunr.it.stemmer);
	
	      // for lunr version 2
	      // this is necessary so that every searched word is also stemmed before
	      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
	      if (this.searchPipeline) {
	        this.searchPipeline.reset();
	        this.searchPipeline.add(lunr.it.stemmer);
	      }
	    };
	
	    /* lunr trimmer function */
	    lunr.it.wordCharacters = 'A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A';
	    lunr.it.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.it.wordCharacters);
	
	    lunr.Pipeline.registerFunction(lunr.it.trimmer, 'trimmer-it');
	
	    /* lunr stemmer function */
	    lunr.it.stemmer = function () {
	      /* create the wrapped stemmer object */
	      var Among = lunr.stemmerSupport.Among,
	          SnowballProgram = lunr.stemmerSupport.SnowballProgram,
	          st = new function ItalianStemmer() {
	        var a_0 = [new Among("", -1, 7), new Among("qu", 0, 6), new Among('\xE1', 0, 1), new Among('\xE9', 0, 2), new Among('\xED', 0, 3), new Among('\xF3', 0, 4), new Among('\xFA', 0, 5)],
	            a_1 = [new Among("", -1, 3), new Among("I", 0, 1), new Among("U", 0, 2)],
	            a_2 = [new Among("la", -1, -1), new Among("cela", 0, -1), new Among("gliela", 0, -1), new Among("mela", 0, -1), new Among("tela", 0, -1), new Among("vela", 0, -1), new Among("le", -1, -1), new Among("cele", 6, -1), new Among("gliele", 6, -1), new Among("mele", 6, -1), new Among("tele", 6, -1), new Among("vele", 6, -1), new Among("ne", -1, -1), new Among("cene", 12, -1), new Among("gliene", 12, -1), new Among("mene", 12, -1), new Among("sene", 12, -1), new Among("tene", 12, -1), new Among("vene", 12, -1), new Among("ci", -1, -1), new Among("li", -1, -1), new Among("celi", 20, -1), new Among("glieli", 20, -1), new Among("meli", 20, -1), new Among("teli", 20, -1), new Among("veli", 20, -1), new Among("gli", 20, -1), new Among("mi", -1, -1), new Among("si", -1, -1), new Among("ti", -1, -1), new Among("vi", -1, -1), new Among("lo", -1, -1), new Among("celo", 31, -1), new Among("glielo", 31, -1), new Among("melo", 31, -1), new Among("telo", 31, -1), new Among("velo", 31, -1)],
	            a_3 = [new Among("ando", -1, 1), new Among("endo", -1, 1), new Among("ar", -1, 2), new Among("er", -1, 2), new Among("ir", -1, 2)],
	            a_4 = [new Among("ic", -1, -1), new Among("abil", -1, -1), new Among("os", -1, -1), new Among("iv", -1, 1)],
	            a_5 = [new Among("ic", -1, 1), new Among("abil", -1, 1), new Among("iv", -1, 1)],
	            a_6 = [new Among("ica", -1, 1), new Among("logia", -1, 3), new Among("osa", -1, 1), new Among("ista", -1, 1), new Among("iva", -1, 9), new Among("anza", -1, 1), new Among("enza", -1, 5), new Among("ice", -1, 1), new Among("atrice", 7, 1), new Among("iche", -1, 1), new Among("logie", -1, 3), new Among("abile", -1, 1), new Among("ibile", -1, 1), new Among("usione", -1, 4), new Among("azione", -1, 2), new Among("uzione", -1, 4), new Among("atore", -1, 2), new Among("ose", -1, 1), new Among("ante", -1, 1), new Among("mente", -1, 1), new Among("amente", 19, 7), new Among("iste", -1, 1), new Among("ive", -1, 9), new Among("anze", -1, 1), new Among("enze", -1, 5), new Among("ici", -1, 1), new Among("atrici", 25, 1), new Among("ichi", -1, 1), new Among("abili", -1, 1), new Among("ibili", -1, 1), new Among("ismi", -1, 1), new Among("usioni", -1, 4), new Among("azioni", -1, 2), new Among("uzioni", -1, 4), new Among("atori", -1, 2), new Among("osi", -1, 1), new Among("anti", -1, 1), new Among("amenti", -1, 6), new Among("imenti", -1, 6), new Among("isti", -1, 1), new Among("ivi", -1, 9), new Among("ico", -1, 1), new Among("ismo", -1, 1), new Among("oso", -1, 1), new Among("amento", -1, 6), new Among("imento", -1, 6), new Among("ivo", -1, 9), new Among('it\xE0', -1, 8), new Among('ist\xE0', -1, 1), new Among('ist\xE8', -1, 1), new Among('ist\xEC', -1, 1)],
	            a_7 = [new Among("isca", -1, 1), new Among("enda", -1, 1), new Among("ata", -1, 1), new Among("ita", -1, 1), new Among("uta", -1, 1), new Among("ava", -1, 1), new Among("eva", -1, 1), new Among("iva", -1, 1), new Among("erebbe", -1, 1), new Among("irebbe", -1, 1), new Among("isce", -1, 1), new Among("ende", -1, 1), new Among("are", -1, 1), new Among("ere", -1, 1), new Among("ire", -1, 1), new Among("asse", -1, 1), new Among("ate", -1, 1), new Among("avate", 16, 1), new Among("evate", 16, 1), new Among("ivate", 16, 1), new Among("ete", -1, 1), new Among("erete", 20, 1), new Among("irete", 20, 1), new Among("ite", -1, 1), new Among("ereste", -1, 1), new Among("ireste", -1, 1), new Among("ute", -1, 1), new Among("erai", -1, 1), new Among("irai", -1, 1), new Among("isci", -1, 1), new Among("endi", -1, 1), new Among("erei", -1, 1), new Among("irei", -1, 1), new Among("assi", -1, 1), new Among("ati", -1, 1), new Among("iti", -1, 1), new Among("eresti", -1, 1), new Among("iresti", -1, 1), new Among("uti", -1, 1), new Among("avi", -1, 1), new Among("evi", -1, 1), new Among("ivi", -1, 1), new Among("isco", -1, 1), new Among("ando", -1, 1), new Among("endo", -1, 1), new Among("Yamo", -1, 1), new Among("iamo", -1, 1), new Among("avamo", -1, 1), new Among("evamo", -1, 1), new Among("ivamo", -1, 1), new Among("eremo", -1, 1), new Among("iremo", -1, 1), new Among("assimo", -1, 1), new Among("ammo", -1, 1), new Among("emmo", -1, 1), new Among("eremmo", 54, 1), new Among("iremmo", 54, 1), new Among("immo", -1, 1), new Among("ano", -1, 1), new Among("iscano", 58, 1), new Among("avano", 58, 1), new Among("evano", 58, 1), new Among("ivano", 58, 1), new Among("eranno", -1, 1), new Among("iranno", -1, 1), new Among("ono", -1, 1), new Among("iscono", 65, 1), new Among("arono", 65, 1), new Among("erono", 65, 1), new Among("irono", 65, 1), new Among("erebbero", -1, 1), new Among("irebbero", -1, 1), new Among("assero", -1, 1), new Among("essero", -1, 1), new Among("issero", -1, 1), new Among("ato", -1, 1), new Among("ito", -1, 1), new Among("uto", -1, 1), new Among("avo", -1, 1), new Among("evo", -1, 1), new Among("ivo", -1, 1), new Among("ar", -1, 1), new Among("ir", -1, 1), new Among('er\xE0', -1, 1), new Among('ir\xE0', -1, 1), new Among('er\xF2', -1, 1), new Among('ir\xF2', -1, 1)],
	            g_v = [17, 65, 16, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 128, 128, 8, 2, 1],
	            g_AEIO = [17, 65, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 128, 128, 8, 2],
	            g_CG = [17],
	            I_p2,
	            I_p1,
	            I_pV,
	            sbp = new SnowballProgram();
	        this.setCurrent = function (word) {
	          sbp.setCurrent(word);
	        };
	        this.getCurrent = function () {
	          return sbp.getCurrent();
	        };
	
	        function habr1(c1, c2, v_1) {
	          if (sbp.eq_s(1, c1)) {
	            sbp.ket = sbp.cursor;
	            if (sbp.in_grouping(g_v, 97, 249)) {
	              sbp.slice_from(c2);
	              sbp.cursor = v_1;
	              return true;
	            }
	          }
	          return false;
	        }
	
	        function r_prelude() {
	          var among_var,
	              v_1 = sbp.cursor,
	              v_2,
	              v_3,
	              v_4;
	          while (true) {
	            sbp.bra = sbp.cursor;
	            among_var = sbp.find_among(a_0, 7);
	            if (among_var) {
	              sbp.ket = sbp.cursor;
	              switch (among_var) {
	                case 1:
	                  sbp.slice_from('\xE0');
	                  continue;
	                case 2:
	                  sbp.slice_from('\xE8');
	                  continue;
	                case 3:
	                  sbp.slice_from('\xEC');
	                  continue;
	                case 4:
	                  sbp.slice_from('\xF2');
	                  continue;
	                case 5:
	                  sbp.slice_from('\xF9');
	                  continue;
	                case 6:
	                  sbp.slice_from("qU");
	                  continue;
	                case 7:
	                  if (sbp.cursor >= sbp.limit) break;
	                  sbp.cursor++;
	                  continue;
	              }
	            }
	            break;
	          }
	          sbp.cursor = v_1;
	          while (true) {
	            v_2 = sbp.cursor;
	            while (true) {
	              v_3 = sbp.cursor;
	              if (sbp.in_grouping(g_v, 97, 249)) {
	                sbp.bra = sbp.cursor;
	                v_4 = sbp.cursor;
	                if (habr1("u", "U", v_3)) break;
	                sbp.cursor = v_4;
	                if (habr1("i", "I", v_3)) break;
	              }
	              sbp.cursor = v_3;
	              if (sbp.cursor >= sbp.limit) {
	                sbp.cursor = v_2;
	                return;
	              }
	              sbp.cursor++;
	            }
	          }
	        }
	
	        function habr2(v_1) {
	          sbp.cursor = v_1;
	          if (!sbp.in_grouping(g_v, 97, 249)) return false;
	          while (!sbp.out_grouping(g_v, 97, 249)) {
	            if (sbp.cursor >= sbp.limit) return false;
	            sbp.cursor++;
	          }
	          return true;
	        }
	
	        function habr3() {
	          if (sbp.in_grouping(g_v, 97, 249)) {
	            var v_1 = sbp.cursor;
	            if (sbp.out_grouping(g_v, 97, 249)) {
	              while (!sbp.in_grouping(g_v, 97, 249)) {
	                if (sbp.cursor >= sbp.limit) return habr2(v_1);
	                sbp.cursor++;
	              }
	              return true;
	            }
	            return habr2(v_1);
	          }
	          return false;
	        }
	
	        function habr4() {
	          var v_1 = sbp.cursor,
	              v_2;
	          if (!habr3()) {
	            sbp.cursor = v_1;
	            if (!sbp.out_grouping(g_v, 97, 249)) return;
	            v_2 = sbp.cursor;
	            if (sbp.out_grouping(g_v, 97, 249)) {
	              while (!sbp.in_grouping(g_v, 97, 249)) {
	                if (sbp.cursor >= sbp.limit) {
	                  sbp.cursor = v_2;
	                  if (sbp.in_grouping(g_v, 97, 249) && sbp.cursor < sbp.limit) sbp.cursor++;
	                  return;
	                }
	                sbp.cursor++;
	              }
	              I_pV = sbp.cursor;
	              return;
	            }
	            sbp.cursor = v_2;
	            if (!sbp.in_grouping(g_v, 97, 249) || sbp.cursor >= sbp.limit) return;
	            sbp.cursor++;
	          }
	          I_pV = sbp.cursor;
	        }
	
	        function habr5() {
	          while (!sbp.in_grouping(g_v, 97, 249)) {
	            if (sbp.cursor >= sbp.limit) return false;
	            sbp.cursor++;
	          }
	          while (!sbp.out_grouping(g_v, 97, 249)) {
	            if (sbp.cursor >= sbp.limit) return false;
	            sbp.cursor++;
	          }
	          return true;
	        }
	
	        function r_mark_regions() {
	          var v_1 = sbp.cursor;
	          I_pV = sbp.limit;
	          I_p1 = I_pV;
	          I_p2 = I_pV;
	          habr4();
	          sbp.cursor = v_1;
	          if (habr5()) {
	            I_p1 = sbp.cursor;
	            if (habr5()) I_p2 = sbp.cursor;
	          }
	        }
	
	        function r_postlude() {
	          var among_var;
	          while (true) {
	            sbp.bra = sbp.cursor;
	            among_var = sbp.find_among(a_1, 3);
	            if (!among_var) break;
	            sbp.ket = sbp.cursor;
	            switch (among_var) {
	              case 1:
	                sbp.slice_from("i");
	                break;
	              case 2:
	                sbp.slice_from("u");
	                break;
	              case 3:
	                if (sbp.cursor >= sbp.limit) return;
	                sbp.cursor++;
	                break;
	            }
	          }
	        }
	
	        function r_RV() {
	          return I_pV <= sbp.cursor;
	        }
	
	        function r_R1() {
	          return I_p1 <= sbp.cursor;
	        }
	
	        function r_R2() {
	          return I_p2 <= sbp.cursor;
	        }
	
	        function r_attached_pronoun() {
	          var among_var;
	          sbp.ket = sbp.cursor;
	          if (sbp.find_among_b(a_2, 37)) {
	            sbp.bra = sbp.cursor;
	            among_var = sbp.find_among_b(a_3, 5);
	            if (among_var && r_RV()) {
	              switch (among_var) {
	                case 1:
	                  sbp.slice_del();
	                  break;
	                case 2:
	                  sbp.slice_from("e");
	                  break;
	              }
	            }
	          }
	        }
	
	        function r_standard_suffix() {
	          var among_var;
	          sbp.ket = sbp.cursor;
	          among_var = sbp.find_among_b(a_6, 51);
	          if (!among_var) return false;
	          sbp.bra = sbp.cursor;
	          switch (among_var) {
	            case 1:
	              if (!r_R2()) return false;
	              sbp.slice_del();
	              break;
	            case 2:
	              if (!r_R2()) return false;
	              sbp.slice_del();
	              sbp.ket = sbp.cursor;
	              if (sbp.eq_s_b(2, "ic")) {
	                sbp.bra = sbp.cursor;
	                if (r_R2()) sbp.slice_del();
	              }
	              break;
	            case 3:
	              if (!r_R2()) return false;
	              sbp.slice_from("log");
	              break;
	            case 4:
	              if (!r_R2()) return false;
	              sbp.slice_from("u");
	              break;
	            case 5:
	              if (!r_R2()) return false;
	              sbp.slice_from("ente");
	              break;
	            case 6:
	              if (!r_RV()) return false;
	              sbp.slice_del();
	              break;
	            case 7:
	              if (!r_R1()) return false;
	              sbp.slice_del();
	              sbp.ket = sbp.cursor;
	              among_var = sbp.find_among_b(a_4, 4);
	              if (among_var) {
	                sbp.bra = sbp.cursor;
	                if (r_R2()) {
	                  sbp.slice_del();
	                  if (among_var == 1) {
	                    sbp.ket = sbp.cursor;
	                    if (sbp.eq_s_b(2, "at")) {
	                      sbp.bra = sbp.cursor;
	                      if (r_R2()) sbp.slice_del();
	                    }
	                  }
	                }
	              }
	              break;
	            case 8:
	              if (!r_R2()) return false;
	              sbp.slice_del();
	              sbp.ket = sbp.cursor;
	              among_var = sbp.find_among_b(a_5, 3);
	              if (among_var) {
	                sbp.bra = sbp.cursor;
	                if (among_var == 1) if (r_R2()) sbp.slice_del();
	              }
	              break;
	            case 9:
	              if (!r_R2()) return false;
	              sbp.slice_del();
	              sbp.ket = sbp.cursor;
	              if (sbp.eq_s_b(2, "at")) {
	                sbp.bra = sbp.cursor;
	                if (r_R2()) {
	                  sbp.slice_del();
	                  sbp.ket = sbp.cursor;
	                  if (sbp.eq_s_b(2, "ic")) {
	                    sbp.bra = sbp.cursor;
	                    if (r_R2()) sbp.slice_del();
	                  }
	                }
	              }
	              break;
	          }
	          return true;
	        }
	
	        function r_verb_suffix() {
	          var among_var, v_1;
	          if (sbp.cursor >= I_pV) {
	            v_1 = sbp.limit_backward;
	            sbp.limit_backward = I_pV;
	            sbp.ket = sbp.cursor;
	            among_var = sbp.find_among_b(a_7, 87);
	            if (among_var) {
	              sbp.bra = sbp.cursor;
	              if (among_var == 1) sbp.slice_del();
	            }
	            sbp.limit_backward = v_1;
	          }
	        }
	
	        function habr6() {
	          var v_1 = sbp.limit - sbp.cursor;
	          sbp.ket = sbp.cursor;
	          if (sbp.in_grouping_b(g_AEIO, 97, 242)) {
	            sbp.bra = sbp.cursor;
	            if (r_RV()) {
	              sbp.slice_del();
	              sbp.ket = sbp.cursor;
	              if (sbp.eq_s_b(1, "i")) {
	                sbp.bra = sbp.cursor;
	                if (r_RV()) {
	                  sbp.slice_del();
	                  return;
	                }
	              }
	            }
	          }
	          sbp.cursor = sbp.limit - v_1;
	        }
	
	        function r_vowel_suffix() {
	          habr6();
	          sbp.ket = sbp.cursor;
	          if (sbp.eq_s_b(1, "h")) {
	            sbp.bra = sbp.cursor;
	            if (sbp.in_grouping_b(g_CG, 99, 103)) if (r_RV()) sbp.slice_del();
	          }
	        }
	        this.stem = function () {
	          var v_1 = sbp.cursor;
	          r_prelude();
	          sbp.cursor = v_1;
	          r_mark_regions();
	          sbp.limit_backward = v_1;
	          sbp.cursor = sbp.limit;
	          r_attached_pronoun();
	          sbp.cursor = sbp.limit;
	          if (!r_standard_suffix()) {
	            sbp.cursor = sbp.limit;
	            r_verb_suffix();
	          }
	          sbp.cursor = sbp.limit;
	          r_vowel_suffix();
	          sbp.cursor = sbp.limit_backward;
	          r_postlude();
	          return true;
	        };
	      }();
	
	      /* and return a function that stems a word for the current locale */
	      return function (token) {
	        // for lunr version 2
	        if (typeof token.update === "function") {
	          return token.update(function (word) {
	            st.setCurrent(word);
	            st.stem();
	            return st.getCurrent();
	          });
	        } else {
	          // for lunr version <= 1
	          st.setCurrent(token);
	          st.stem();
	          return st.getCurrent();
	        }
	      };
	    }();
	
	    lunr.Pipeline.registerFunction(lunr.it.stemmer, 'stemmer-it');
	
	    lunr.it.stopWordFilter = lunr.generateStopWordFilter('a abbia abbiamo abbiano abbiate ad agl agli ai al all alla alle allo anche avemmo avendo avesse avessero avessi avessimo aveste avesti avete aveva avevamo avevano avevate avevi avevo avrai avranno avrebbe avrebbero avrei avremmo avremo avreste avresti avrete avrà avrò avuta avute avuti avuto c che chi ci coi col come con contro cui da dagl dagli dai dal dall dalla dalle dallo degl degli dei del dell della delle dello di dov dove e ebbe ebbero ebbi ed era erano eravamo eravate eri ero essendo faccia facciamo facciano facciate faccio facemmo facendo facesse facessero facessi facessimo faceste facesti faceva facevamo facevano facevate facevi facevo fai fanno farai faranno farebbe farebbero farei faremmo faremo fareste faresti farete farà farò fece fecero feci fosse fossero fossi fossimo foste fosti fu fui fummo furono gli ha hai hanno ho i il in io l la le lei li lo loro lui ma mi mia mie miei mio ne negl negli nei nel nell nella nelle nello noi non nostra nostre nostri nostro o per perché più quale quanta quante quanti quanto quella quelle quelli quello questa queste questi questo sarai saranno sarebbe sarebbero sarei saremmo saremo sareste saresti sarete sarà sarò se sei si sia siamo siano siate siete sono sta stai stando stanno starai staranno starebbe starebbero starei staremmo staremo stareste staresti starete starà starò stava stavamo stavano stavate stavi stavo stemmo stesse stessero stessi stessimo steste stesti stette stettero stetti stia stiamo stiano stiate sto su sua sue sugl sugli sui sul sull sulla sulle sullo suo suoi ti tra tu tua tue tuo tuoi tutti tutto un una uno vi voi vostra vostre vostri vostro è'.split(' '));
	
	    lunr.Pipeline.registerFunction(lunr.it.stopWordFilter, 'stopWordFilter-it');
	  };
	});

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* global $, google */
	
	
	var _template = __webpack_require__(13);
	
	var _template2 = _interopRequireDefault(_template);
	
	var _templateGM = __webpack_require__(14);
	
	var _templateGM2 = _interopRequireDefault(_templateGM);
	
	var _bases = __webpack_require__(5);
	
	var _bases2 = _interopRequireDefault(_bases);
	
	var _language = __webpack_require__(6);
	
	var _language2 = _interopRequireDefault(_language);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SearchResultsList = function () {
	  function SearchResultsList(field) {
	    _classCallCheck(this, SearchResultsList);
	
	    this.field = field;
	    this.node = null;
	    this.clicked = false;
	    this.showList = true;
	    this.geocoder = null;
	    this.init();
	  }
	
	  _createClass(SearchResultsList, [{
	    key: 'init',
	    value: function init() {
	      var _this = this;
	
	      this.node = $(document.getElementsByName(this.field)[0]).next().children().children();
	      this.geocoder = new google.maps.Geocoder();
	      $(document).click(function (event) {
	        if ($(event.target).closest('.searchResult').length > 0) {
	          _this.hide();
	          event.stopPropagation();
	        }
	      });
	    }
	  }, {
	    key: 'show',
	    value: function show(data) {
	      var result = data.slice(0, 5).map(function (el) {
	        var element = _bases2.default.base[el.ref];
	        return {
	          name: element[_language2.default],
	          _id: element._id, // eslint-disable-line no-underscore-dangle
	          sortOrder: element.sortOrder
	        };
	      });
	      var sortedResult = result.sort(function (a, b) {
	        if (a.sortOrder < b.sortOrder) return -1;
	        if (a.sortOrder > b.sortOrder) return 1;
	        return 0;
	      });
	      if (!this.clicked) {
	        this.node.html('').json2html(sortedResult, _template2.default, {
	          append: false
	        });
	      }
	      $('.searchResult li').off();
	      this.bindClickEvent('custom');
	      if (this.showList) {
	        this.showList = false;
	        $(document.getElementsByName(this.field)[0]).next().fadeIn(150);
	      }
	    }
	  }, {
	    key: 'showGoogle',
	    value: function showGoogle(data) {
	      // console.log('data,this.showList',data,this.showList);
	      var result = data.map(function (element) {
	        var el = element;
	        var mStrings = el.matched_substrings[0];
	        return {
	          description: el.description,
	          before: el.terms[0].value.substr(0, mStrings.offset),
	          match: el.terms[0].value.substr(mStrings.offset, mStrings.length),
	          name: el.terms[0].value.slice(mStrings.offset + mStrings.length),
	          address: el.terms.reduce(function (addr, addrEl, i) {
	            return i > 0 ? addr + ' ' + addrEl.value : addr;
	          }, ''),
	          place_id: el.place_id
	        };
	      });
	      if (!this.clicked) {
	        // console.log('result',result);
	        this.node.html('').json2html(result, _templateGM2.default, {
	          append: false
	        });
	      }
	      $('.searchResult li').off();
	      this.bindClickEvent('google');
	      if (this.showList) {
	        this.showList = false;
	        $(document.getElementsByName(this.field)[0]).next().fadeIn(150);
	      }
	    }
	  }, {
	    key: 'hide',
	    value: function hide() {
	      this.showList = true;
	      $(document.getElementsByName(this.field)[0]).next().fadeOut(100);
	      $('.searchResult li').off();
	    }
	  }, {
	    key: 'bindClickEvent',
	    value: function bindClickEvent(type) {
	      var self = this;
	      if (type === 'custom') {
	        $('.searchResult li').click(function handler() {
	          // self.clicked = true;
	          $(this).parent().parent().parent().prev().val($(this).text());
	          $('input[name="' + self.field + 'Id"]').val($(this).data('id'));
	          document.getElementsByName(self.field + 'Data')[0].value = '';
	          self.hide();
	        });
	      } else {
	        $('.searchResult li').click(function handler() {
	          document.getElementsByName('action')[0].value = 'newform';
	          self.hide();
	          document.getElementsByName(self.field)[0].value = this.dataset.value;
	          self.geocoder.geocode({ placeId: this.dataset.id, language: 'en', region: 'it' }, function (results, status) {
	            if (status === google.maps.GeocoderStatus.OK) {
	              var place = results[0];
	              var placeData = {};
	              placeData.formatted_address = place.formatted_address;
	              placeData.name = place.name;
	              placeData.city = place.address_components.filter(function (el) {
	                return el.types[0] === 'locality' || el.types[0] === 'administrative_area_level_3';
	              });
	              $('input[name="' + self.field + 'Id"]').val('');
	              document.getElementsByName(self.field + 'Data')[0].value = JSON.stringify(placeData);
	            } else {
	              console.log('Can\'t find address: ' + status); // eslint-disable-line no-console
	            }
	          });
	        });
	      }
	    }
	  }]);
	
	  return SearchResultsList;
	}();
	
	exports.default = SearchResultsList;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 13 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  "tag": "li",
	  "data-id": "${_id}",
	  "html": "${name}",
	  "children": [{
	    "tag": "strong",
	    "html": " ${code}"
	  }]
	};

/***/ }),
/* 14 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = {
		"tag": "li",
		"data-id": "${place_id}",
		"data-value": "${description}",
		"children": [{
			"tag": "div",
			"children": [{
				"tag": "span",
				"html": "${before}"
			}, {
				"tag": "b",
				"class": "match",
				"html": "${match}"
			}, {
				"tag": "span",
				"class": "name",
				"html": "${name}"
			}]
		}, {
			"tag": "em",
			"class": "address",
			"html": "${address}"
		}]
	};

/***/ }),
/* 15 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = alphanum;
	function alphanum(event) {
		if (document.documentElement.className.search('mobile') + 1) return true;
		if (document.documentElement.className.search('tablet') + 1) return true;
		if (57 >= event.keyCode && event.keyCode >= 48 || 122 >= event.keyCode && event.keyCode >= 96 || 90 >= event.keyCode && event.keyCode >= 65 || event.keyCode == 8 || event.keyCode == 46 || event.keyCode == 13 || event.keyCode == 32) {
			return true;
		} else {
			return false;
		}
	}

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// scripts/bundle.js